import React, { useEffect, useState } from "react";
import "../SeasonalEvent/SeasonalEvent.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import img1 from "../../assets/img/event-imgs/big-1.jpg";
import { useNavigate, useParams } from "react-router-dom";
import { MdOutlineSchedule } from "react-icons/md";
import { API_DOMAIN, GlobalConstants } from "../../utils/GlobalConst";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import moment from "moment";
import { Elements } from "@stripe/react-stripe-js";
import SeasonalCheckOut from "./SeasonalCheckOut";
import { loadStripe } from "@stripe/stripe-js";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { BiLogIn } from "react-icons/bi";
const xpath = require("xpath");
const dom = require("xmldom").DOMParser;
const stripePromise = loadStripe(
  "pk_test_51P1NMVRt5JCS1mrQ0R3SFrT76QoIF2ijszPDICSIVbRe3e8no4MMslSTWnwQcgHNBNXydKPCPIsWTccst8e367VO00xxgTd9xC"
);
function SeasonalEvent() {
  const navigate = useNavigate();
  const { seasonalticketid } = useParams();
  console.log(seasonalticketid);
  const [eventDetails, setEventDetails] = useState([]);
  const [seasonName, setSeasonName] = useState([]);
  const [seasonCount, setSeasonCount] = useState([]);
  const [seasonPrice, setSeasonPrice] = useState([]);
  const [seasonCurrency, setSeasonCurrency] = useState([]);
  const [seasonData, setSeasonData] = useState([]);
  const [seasonVenueId, setSeasonVenueId] = useState("");
  const [seasonTicketId, setSeasonTicketId] = useState("");
  const [showSeats, setShowSeats] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [clientSecret, setClientSecret] = useState("");
  const [isParkingPass, setIsParkingPass] = useState(false);
  const [isFoodandDrink, setIsFoodandDrink] = useState(false);
  const [parkingPass, setParkingPass] = useState([]);
  const appearance = {
    theme: "stripe",
  };
  const options = {
    clientSecret,
    appearance,
  };
  const [seasonSeatList, setSeasonSeatList] = useState([]);
  const [showSection, setShowSection] = useState("");
  const [eveid, setEveid] = useState("");
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [openloginInfo, setOpenloginInfo] = useState(false);
  const handleCloseloginInfo = () => {
    setOpenloginInfo(false);
    navigate("/signin", {
      state: { pageLand: window.location.pathname },
    });
  };
  const loginCheckHandle = () => {
    var token = sessionStorage.getItem("token");
    if (token === null || token === undefined || token === "") {
      setOpenloginInfo(true);
    } else {
      getVenueDetails();
      getSeatDetails(eveid, showSection, seasonSeatList);

      setShowSeats(true);
    }
  };
  // language variable
  const [text_total, setText_total] = useState("Total");
  const [text_billing, setText_billing] = useState("Billing Information");
  const [text_info_please_login, setText_info_please_login] = useState(
    "Please Login To Proceed Further"
  );
  const [text_quantity, setText_quantity] = useState("Quantity");
  const [text_seat, setText_seat] = useState("Seat");
  const [text_price, setText_price] = useState("Price");
  const [text_ownerpnem, setText_ownerpnem] = useState(
    "Owner Email"
  );
  const [text_owner_fullName, setText_owner_fullName] =
    useState("Owner Full Name");
  const [text_onceagain, setText_onceagain] = useState(
    "Please Check Email Once Again!"
  );
  const [text_usernotfound, setText_usernotfound] = useState("User Not Found");
  const [text_confirm, setText_confirm] = useState("Confirm");
  const [text_checkout, setText_checkout] = useState("Check Out");
  const [text_selectseats, setText_selectseats] = useState("Select Seats");
  const [text_back, setText_back] = useState("Back");
  const [text_eventsincluded, setText_eventsincluded] =
    useState("Events Included");
  const [text_events, setText_events] = useState("Events");
  const [text_okay, setText_okay] = useState("Okay");
  // new language variable
  const [text_pass, setText_pass] = useState("Pass");
  const [text_schedule, setTest_schedule] = useState("Schedule");
  const [text_amenities, setText_amenities] = useState("Amenities");
  const [text_foodDrinkInc, setText_foodDrinkInc] = useState(
    "Food and drink included"
  );
  const [text_na, setText_na] = useState("NA");
  const [text_parkingpass, setText_parkingpass] = useState("Parking Pass");
  const [text_parking, setText_parking] = useState("Parking");
  const [text_venueAddress, setText_venueAddress] = useState("Venue Address");
  const [text_pricePerTicket, setText_pricePerTicket] =
    useState("Price Per Pass");
  const [text_tickets, setText_tickets] = useState("Tickets");
  const [text_ticketlist, setText_ticketlist] = useState("Ticket List");
  const [text_taxes_info, setText_taxes_info] = useState(
    "Price is inclusive of all applicable Taxes"
  );

  const getselectedSeason = () => {
    var API_URL =
      API_DOMAIN +
      `seasonal/get/seasonalticket?seasonalticketid=${seasonalticketid}`;

    let headerConfig = {
      headers: {
        authorization: "bearer " + sessionStorage.getItem("token"),
      },
    };

    axios
      .get(API_URL, headerConfig)
      .then((response) => {
        console.log("selected season data ", response.data.data);
        const res = response.data.data;
        const sortdata = res.event_details;
        sortdata.sort(
          (a, b) => new Date(a?.StartDateSort) - new Date(b?.StartDateSort)
        );
        console.log(sortdata);
        setEventDetails(sortdata);
        setSeasonPrice(res.price);
        setSeasonName(res.ticketname);
        setSeasonCount(res.event_count);
        setSeasonCurrency(res.currency);
        setSeasonVenueId(res.venueid);
        setSeasonTicketId(res.seasonalticketid);
        setIsParkingPass(res.isParking);
        setIsFoodandDrink(res.isFoodAndBeverages);
        setParkingPass(res.ParkingLevel);
        var SL = res.seatList;
        var eid = SL[0].event_unique_id;
        var catid = SL[0].seat_category_id;
        console.log(SL);
        setShowSection(catid);
        setSeasonSeatList(SL);
        setEveid(eid);

        var season = [res];
        setSeasonData(season);
      })
      .catch((error) => {
        toast.error(error.response.data.message);
        if (error.response.status === 427) {
          sessionStorage.clear();
          localStorage.clear();
          setTimeout(() => {
            navigate("/");
          }, 1000);
        } else {
          toast.error(error.response.data.message);
        }
      });
  };

  useEffect(() => {
    getselectedSeason();
  }, []);

  const getEventDetails = (uniqueEventIds) => {
    const dummy = [];
    for (let i = 0; i < uniqueEventIds.length; i++) {
      var type = "select";
      var event_unique_id = uniqueEventIds[i];
      var API_URL =
        API_DOMAIN +
        "event/public?type=" +
        type +
        "&event_unique_id=" +
        event_unique_id;

      axios
        .get(API_URL)
        .then(function (response) {
          console.log("Detaied Event", response.data.data[0]);
          dummy.push(response.data.data[0]);
          console.log("in loop", dummy);
          setEventDetails(dummy);
        })
        .catch(function (error) {
          if (error.response.status === 427) {
            sessionStorage.clear();
            localStorage.clear();
            setTimeout(() => {
              navigate("/");
            }, 1000);
          } else {
            toast.error(error.response.data.message);
          }
        })
        .then(function () {});
    }
  };

  const getVenueDetails = () => {
    var API_URL = API_DOMAIN + "venue/venue";

    let headerConfig = {
      headers: {
        authorization: "bearer " + sessionStorage.getItem("token"),
      },
    };

    axios
      .get(API_URL, headerConfig)
      .then(function (response) {
        console.log("venue", response.data.data);
        let darrr = response.data.data;
        darrr = darrr.filter((v) => v?.venueid === seasonVenueId);
        console.log("filter venue", darrr);
      })
      .catch(function (error) {
        console.log(error);
        if (error.response.status === 427) {
          sessionStorage.clear();
          localStorage.clear();
          setTimeout(() => {
            navigate("/");
          }, 1000);
        } else {
          toast.error(error.response.data.message);
        }
      })
      .then(function () {});
  };
  const [seatDetails, setseatDetails] = useState({});

  console.log("object", eventDetails);

  const allEventData = [
    {
      EventTitle: "TEST-BASKETBALL",
      date: "Jan 26 - Jan 30",
      time: "Fri,12:00 PM ",
      sell_currency: "$",
      TotalAmount: "450",
    },
    {
      EventTitle: "Test-Event",
      date: "Jan 28 - Jan 30",
      time: "Fri,12:00 PM ",
      sell_currency: "$",
      TotalAmount: "250",
    },
  ];

  // Book mark Start

  const [selectedSectorName, setSelectedSectorName] = useState("");

  const getSeatDetails = (eid, catid, SL) => {
    var API_URL =
      API_DOMAIN +
      `seat/view/event/seat?event_unique_id=${eid}&seat_category_id=${catid}`;

    let headerConfig = {
      headers: {
        authorization: "bearer " + sessionStorage.getItem("token"),
      },
    };

    axios
      .get(API_URL, headerConfig)
      .then(function (response) {
        console.log("seatdetails List", response);
        let data = response.data.data;
        var dataMain = data;
        setSelectedSectorName(dataMain[0]?.seat_category);
        const newArr = dataMain.map((v) => ({ ...v, seasonSeats: false }));
        ArrayTOObject(newArr, SL);
      })
      .catch(function (error) {
        console.log(error);
        if (error.response.status === 427) {
          sessionStorage.clear();
          localStorage.clear();
          setTimeout(() => {
            navigate("/");
          }, 1000);
        } else {
          toast.error(error.response.data.message);
        }
      })
      .then(function () {});
  };
  const ArrayTOObject = (arr, SL) => {
    for (let i = 0; i < arr.length; i++) {
      for (let j = 0; j < SL.length; j++) {
        if (arr[i].seat_name === SL[j].seat_name) {
          console.log("marched");
          arr[i].seasonSeats = true;
        }
      }
    }
    var seatss = arr,
      result = seatss.reduce(function (r, a) {
        r[a.rowstart] = r[a.rowstart] || [];
        r[a.rowstart].push(a);
        return r;
      }, Object.create(null));
    //sorting below
    var orderedData = Object.keys(result)
      .sort()
      .reduce((obj, key) => {
        obj[key] = result[key];
        return obj;
      }, {});
    //objs.sort((a,b) => a.column - b.column);
    for (const key in orderedData) {
      orderedData[key].sort((a, b) => a.column - b.column);
    }
    console.log(seasonSeatList, arr);

    setseatDetails(orderedData);
  };
  // Book mark End
  const [selectedIds, setSelectedIds] = useState([]);
  const [selecteSeatName, setSelecteSeatName] = useState([]);
  const handleSelectSeats = (seat) => {
    const isSelected = selectedIds.includes(seat.seat_unique_id);
    setSelectedIds((prevIds) =>
      isSelected
        ? prevIds.filter((prevId) => prevId !== seat.seat_unique_id)
        : [...prevIds, seat.seat_unique_id]
    );
    const isSelectedName = selecteSeatName.includes(seat.seat_name);
    setSelecteSeatName((prevName) =>
      isSelectedName
        ? prevName.filter((prevName) => prevName !== seat.seat_name)
        : [...prevName, seat.seat_name]
    );
  };
  console.log("selectedIds", selectedIds, selecteSeatName);
  const [showOwnerDetails, setShowOwnerDetails] = useState(false);

  const handleSeasonCheckout = () => {
    var API_URL = API_DOMAIN + "seasonal/checkout";

    let headerConfig = {
      headers: {
        authorization: "bearer " + sessionStorage.getItem("token"),
      },
    };
    var data = {
      seasonalticketid: seasonTicketId,
      seatList: selectedIds,
    };
    axios
      .post(API_URL, data, headerConfig)
      .then(function (response) {
        console.log("seasonal checkout", response.data.data);
        setClientSecret(response.data.data.client_secret);
        setShowOwnerDetails(true);
        sessionStorage.setItem("seasonSeatId", JSON.stringify(selectedIds));
        sessionStorage.setItem("seasonDetails", JSON.stringify(seasonData));
      })
      .catch(function (error) {
        console.log(error);
        if (error.response.status === 427) {
          sessionStorage.clear();
          localStorage.clear();
          setTimeout(() => {
            navigate("/");
          }, 1000);
        } else {
          toast.error(error.response.data.message);
        }
      })
      .then(function () {});
  };
  const [SelectedseatDetailsarray, setSelectedseatDetailsarray] = useState([]);
  const [ownerinputData, setOwnerInputData] = useState([]);

  const SeatDataBeforNext = (check, seatD, seatid) => {
    if (check === true) {
      let darrr = [...SelectedseatDetailsarray];

      darrr.push({
        seatD,
      });
      console.log("darrr", darrr);
      setSelectedseatDetailsarray(darrr);
      setOwnerInputData(
        darrr.map((item) => ({
          seat_unique_id: item?.seatD.seat_unique_id,
          ownername: sessionStorage.getItem("userfirstname"),
          owneremail: sessionStorage.getItem("useremail"),
          verify: false,
        }))
      );

      console.log(
        "array ----",
        SelectedseatDetailsarray,
        ",.,.,.",
        ownerinputData
      );
    } else {
      let darrr = [...SelectedseatDetailsarray];
      darrr = darrr.filter((v) => v?.seatD.seat_unique_id !== seatid);
      setSelectedseatDetailsarray(darrr);
      console.log("dis", SelectedseatDetailsarray, ",.,.,.", ownerinputData);
    }
    console.log("][]][]", SelectedseatDetailsarray, ",.,.,.", ownerinputData);
  };
  const [showOwnerErr, setShowOwnerErr] = useState(false);
  const [notFoundList, setNotFoundList] = useState([]);

  const handleInputChangeOwnerName = (e, rowIndex) => {
    const newValue = e.target.value;
    setOwnerInputData((prevInputData) => {
      const updatedInputData = [...prevInputData];
      updatedInputData[rowIndex].ownername = newValue;
      return updatedInputData;
    });
  };
  const handleInputChangeOwnerEmail = (e, rowIndex) => {
    const newValue = e.target.value;
    setOwnerInputData((prevInputData) => {
      const updatedInputData = [...prevInputData];
      updatedInputData[rowIndex].owneremail = newValue;
      return updatedInputData;
    });
  };
  const confirmOwnerHandle = () => {
    for (let i = 0; i < ownerinputData.length; i++) {
      checkValidOwnerEmail(ownerinputData[i]?.owneremail);
    }
  };
  const [usercount, setUsercount] = useState(null);
  const checkValidOwnerEmail = (email) => {
    setUsercount(0);
    var API_URL = API_DOMAIN + `user/isuserexist?email=${email}`;

    let headerConfig = {
      headers: {
        authorization: "bearer " + sessionStorage.getItem("token"),
      },
    };

    var data = {};
    axios
      .post(API_URL, data, headerConfig)
      .then(function (response) {
        console.log("verify", response);
        if (response?.status === 200) {
          setUsercount((usercount) => usercount + 1);
        }
      })
      .catch(function (error) {
        if (error.response.status === 427) {
          sessionStorage.clear();
          localStorage.clear();
          setTimeout(() => {
            navigate("/");
          }, 1000);
        } else if (error.response.data.message === "user not found") {
          setShowOwnerErr(true);
          setNotFoundList([...notFoundList, error.response.data.data.email]);
        } else {
          toast.error(error.response.data.message);
        }
      })
      .then(function () {});
  };
  useEffect(() => {
    if (usercount === ownerinputData.length) {
      setShowPayment(true);
    }
  }, [usercount]);
  useEffect(() => {
    try {
      SetLanguageText();
    } catch (err) {
      console.log("" + err);
    }
  }, []);
  const SetLanguageText = () => {
    try {
      var xml = localStorage.getItem(GlobalConstants.session_lang_xml);
      var doc = new dom().parseFromString(xml);
      setText_total(
        xpath.select1("/resources/string[@name='text_total']", doc).firstChild
          .data
      );
      setText_billing(
        xpath.select1("/resources/string[@name='text_billing']", doc).firstChild
          .data
      );
      setText_info_please_login(
        xpath.select1("/resources/string[@name='text_info_please_login']", doc)
          .firstChild.data
      );
      setText_quantity(
        xpath.select1("/resources/string[@name='text_quantity']", doc)
          .firstChild.data
      );
      setText_seat(
        xpath.select1("/resources/string[@name='text_seat']", doc).firstChild
          .data
      );
      setText_price(
        xpath.select1("/resources/string[@name='text_price']", doc).firstChild
          .data
      );
      setText_ownerpnem(
        xpath.select1("/resources/string[@name='text_ownerpnem']", doc)
          .firstChild.data
      );
      setText_owner_fullName(
        xpath.select1("/resources/string[@name='text_owner_fullName']", doc)
          .firstChild.data
      );
      setText_onceagain(
        xpath.select1("/resources/string[@name='text_onceagain']", doc)
          .firstChild.data
      );
      setText_usernotfound(
        xpath.select1("/resources/string[@name='text_usernotfound']", doc)
          .firstChild.data
      );
      setText_confirm(
        xpath.select1("/resources/string[@name='text_confirm']", doc).firstChild
          .data
      );
      setText_checkout(
        xpath.select1("/resources/string[@name='text_checkout']", doc)
          .firstChild.data
      );
      setText_selectseats(
        xpath.select1("/resources/string[@name='text_selectseats']", doc)
          .firstChild.data
      );
      setText_back(
        xpath.select1("/resources/string[@name='text_back']", doc).firstChild
          .data
      );
      setText_eventsincluded(
        xpath.select1("/resources/string[@name='text_eventsincluded']", doc)
          .firstChild.data
      );
      setText_events(
        xpath.select1("/resources/string[@name='text_events']", doc).firstChild
          .data
      );
      setText_okay(
        xpath.select1("/resources/string[@name='text_okay']", doc).firstChild
          .data
      );
      setText_pass(
        xpath.select1("/resources/string[@name='text_pass']", doc).firstChild
          .data
      );
      setTest_schedule(
        xpath.select1("/resources/string[@name='text_schedule']", doc)
          .firstChild.data
      );
      setText_amenities(
        xpath.select1("/resources/string[@name='text_amenities']", doc)
          .firstChild.data
      );
      setText_foodDrinkInc(
        xpath.select1("/resources/string[@name='text_foodDrinkInc']", doc)
          .firstChild.data
      );
      setText_na(
        xpath.select1("/resources/string[@name='text_na']", doc).firstChild.data
      );
      setText_parkingpass(
        xpath.select1("/resources/string[@name='text_parkingpass']", doc)
          .firstChild.data
      );
      setText_parking(
        xpath.select1("/resources/string[@name='text_parking']", doc).firstChild
          .data
      );
      setText_venueAddress(
        xpath.select1("/resources/string[@name='text_venueAddress']", doc)
          .firstChild.data
      );
      setText_pricePerTicket(
        xpath.select1("/resources/string[@name='text_pricePerTicket']", doc)
          .firstChild.data
      );
      setText_tickets(
        xpath.select1("/resources/string[@name='text_tickets']", doc).firstChild
          .data
      );
      setText_ticketlist(
        xpath.select1("/resources/string[@name='text_ticketlist']", doc)
          .firstChild.data
      );
      setText_taxes_info(
        xpath.select1("/resources/string[@name='text_taxes_info']", doc)
          .firstChild.data
      );
    } catch (ert) {}
  };
  return (
    <>
      <Header />
      <div className="wrapper" id="otherPages">
        <div className="hero-banner">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-7 col-lg-9 col-md-10">
                <div className="hero-banner-content">
                  <h2>
                    {seasonName} {text_pass}
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="explore-events ">
          <div className="container d-flex justify-content-end pt-5 pb-3">
            {showPayment === false ? (
              <>
                {showSeats === false ? (
                  <></>
                ) : (
                  <>
                    <div className="">
                      <div className="mt-4">
                        <button
                          className="main-btn"
                          onClick={() => [
                            setShowSeats(false),
                            setShowOwnerDetails(false),
                          ]}
                        >
                          {text_back}
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </>
            ) : (
              <></>
            )}
          </div>
          <div className="container">
            <div className="row">
              {showPayment === false ? (
                <>
                  {showSeats === false ? (
                    <>
                      <div className="row mt-4">
                        <div className="col-xl-8 col-lg-12 col-md-12">
                          {eventDetails.length > 0 &&
                            eventDetails.map((e, index) => {
                              return (
                                <>
                                  {" "}
                                  <div
                                    className="new-card-team d-flex justify-content-between  mt-3"
                                    onClick={() =>
                                      navigate(
                                        `/event-details/${e?.event_unique_id}`
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    <div className="d-flex flex-wrap">
                                      <img
                                        src={
                                          e?.EventImagePath === "path"
                                            ? img1
                                            : e?.EventImagePath
                                        }
                                        alt=""
                                        className="card-img-team"
                                      />
                                      <div className="m-3 responsive-team-card">
                                        <h3> {e.EventTitle}</h3>
                                        <span>
                                          {moment
                                            .utc(e?.StartDate)
                                            .format("DD MMM, yyyy")}{" "}
                                          •{" "}
                                          {moment
                                            .utc(e.StartDate)
                                            .format("ddd")}
                                          ,{" "}
                                          {moment
                                            .utc(e?.StartTime)
                                            .format("h:mmA")}
                                        </span>{" "}
                                        <br />
                                        <span>
                                          {e.venuedetails.length === 0 ? (
                                            ""
                                          ) : (
                                            <>
                                              <svg
                                                stroke="currentColor"
                                                fill="currentColor"
                                                stroke-width="0"
                                                viewBox="0 0 512 512"
                                                className="location-icon"
                                                height="10px"
                                                width="10px"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path
                                                  fill="none"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="22"
                                                  d="M256 48c-79.5 0-144 61.39-144 137 0 87 96 224.87 131.25 272.49a15.77 15.77 0 0025.5 0C304 409.89 400 272.07 400 185c0-75.61-64.5-137-144-137z"
                                                ></path>
                                                <circle
                                                  cx="256"
                                                  cy="192"
                                                  r="48"
                                                  fill="none"
                                                  stroke-linecap="round"
                                                  stroke-linejoin="round"
                                                  stroke-width="32"
                                                ></circle>
                                              </svg>
                                              {e?.venuedetails[0].venuename} ({" "}
                                              {e?.venuedetails[0].address},{" "}
                                              {e?.venuedetails[0].city},{" "}
                                              {e?.venuedetails[0].state},{" "}
                                              {e?.venuedetails[0].country},{" "}
                                              {e?.venuedetails[0].zipcode})
                                            </>
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              );
                            })}
                        </div>
                        <div className="col-xl-4 col-lg-12 col-md-12">
                          <div className="main-card mt-2">
                            <div className="bp-title">
                              <h4>
                                {seasonName} {text_pass}
                              </h4>
                            </div>
                            <div className="p_30">
                              <div className="event-dt-right-group mt-3">
                                <div className="event-dt-right-icon">
                                  <MdOutlineSchedule />
                                </div>
                                <div className="event-dt-right-content">
                                  <h4>{text_schedule}</h4>
                                  <h5 className="mb-0">
                                    {seasonCount} {text_events}
                                  </h5>
                                </div>
                              </div>
                              <div className="event-dt-right-group">
                                <div className="event-dt-right-icon">
                                  <MdOutlineSchedule />
                                </div>
                                <div className="event-dt-right-content">
                                  <h4>{text_amenities}</h4>
                                  <h5 className="mb-0">
                                    {isFoodandDrink === true ? (
                                      <>
                                        {" "}
                                        {""}
                                        {text_foodDrinkInc}
                                      </>
                                    ) : (
                                      <>{text_na}</>
                                    )}
                                  </h5>
                                </div>
                              </div>
                              <div className="event-dt-right-group">
                                <div className="event-dt-right-icon">
                                  <MdOutlineSchedule />
                                </div>
                                <div className="event-dt-right-content">
                                  <h4>{text_parking}</h4>
                                  <h5 className="mb-0">
                                    {isParkingPass === true ? (
                                      <>
                                        {" "}
                                        {""}
                                        {parkingPass} {text_parkingpass}
                                      </>
                                    ) : (
                                      <>{text_na}</>
                                    )}
                                  </h5>
                                </div>
                              </div>
                              <div className="event-dt-right-group">
                                <div className="event-dt-right-icon">
                                  <MdOutlineSchedule />
                                </div>
                                <div className="event-dt-right-content">
                                  <h4>{text_price}</h4>
                                  <h5 className="mb-0">
                                    {seasonCurrency} {seasonPrice}
                                  </h5>
                                </div>
                              </div>
                              <button
                                className="main-btn btn-hover h_50 w-100"
                                type="button"
                                onClick={() => loginCheckHandle()}
                              >
                                {text_selectseats}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="mt-4">
                        <div className="row">
                          <div className="col-xl-8 col-lg-12 col-md-12">
                            {showOwnerDetails === false ? (
                              <>
                                <div className="">
                                  <div className="res-stadium">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      version="1.0"
                                      style={{
                                        shapeRendering: "geometricPrecision",
                                      }}
                                      width="600"
                                      viewBox="0 0 290 210"
                                    >
                                      <defs>
                                        <filter
                                          style={{ colorInterpolation: "sRGB" }}
                                          id="filter6633"
                                        >
                                          <feColorMatrix
                                            result="result2"
                                            type="luminanceToAlpha"
                                            in="SourceGraphic"
                                          ></feColorMatrix>
                                          <feDiffuseLighting
                                            lighting-color="#ffffff"
                                            in="result2"
                                            diffuseConstant="0.5"
                                            result="result1"
                                            surfaceScale="15"
                                          >
                                            <feDistantLight
                                              azimuth="225"
                                              elevation="10"
                                            ></feDistantLight>
                                          </feDiffuseLighting>
                                          <feComposite
                                            result="result9"
                                            operator="arithmetic"
                                            k2="1"
                                            k3="0.9"
                                            in2="SourceGraphic"
                                          ></feComposite>
                                          <feComposite
                                            in2="SourceGraphic"
                                            result="result7"
                                            operator="in"
                                            in="result9"
                                          ></feComposite>
                                        </filter>
                                      </defs>
                                      <g id="ostalo" className="svg_ostalo">
                                        {" "}
                                        <path
                                          id="path5797-8-24-2-6"
                                          d="M 149.91916,24.019176 V 32.674414 C 125.23748,33.190203 102.88998,40.435907 86.245931,51.960036 L 79.924824,45.870572 L 75.366743,49.428636 L 81.347219,55.60697 C 65.927711,67.954459 56.533134,84.317525 56.533145,102.27124 C 56.562356,119.17373 65.086434,135.49142 80.515462,148.18079 L 74.481665,154.2685 L 79.45621,158.33131 L 85.432538,152.00604 C 102.7618,164.41074 125.653,171.35697 149.92686,171.86631 V 180.53281 H 156.27937 V 171.84794 C 181.40098,171.19151 204.06422,163.56414 220.69311,151.56115 L 226.83769,157.71163 L 231.35785,153.91008 L 225.40878,147.90413 C 240.07787,135.68415 248.96139,119.73004 248.9616,102.27124 C 248.9616,84.318065 239.57014,67.953724 224.15166,55.60579 L 230.08265,49.388121 L 225.15462,45.304203 L 219.03967,51.808379 C 202.57575,40.477647 180.57161,33.327003 156.27166,32.693375 V 24.019176 Z M 152.62295,36.615192 C 202.20979,36.615169 242.40784,65.705942 242.40765,101.59115 C 242.40784,137.47637 202.20979,166.56715 152.62295,166.56712 C 103.03612,166.56715 62.838089,137.47637 62.838261,101.59115 C 62.838078,65.705942 103.03612,36.615169 152.62295,36.615192 Z"
                                          style={{
                                            display: "inline",
                                            opacity: "1",
                                            fill: "#ffffff",
                                            fillOpacity: "1",
                                            stroke: "none",
                                            strokeWidth: "0.29118595",
                                            strokeLinecap: "butt",
                                            strokeLinejoin: "round",
                                            strokeMiterlimit: 4,
                                            strokeDasharray: "none",
                                            strokeDashoffset: "8.45947647",
                                            stopOpacity: "1",
                                            paintOrder: "markers fill stroke",
                                          }}
                                        ></path>
                                        <text
                                          id="text3666"
                                          y="15.273439"
                                          x="127.95478"
                                          style={{
                                            fontStyle: "Normal",
                                            fontVariant: "normal",
                                            fontWeight: "normal",
                                            fontStretch: "normal",
                                            fontSize: "7.4083333px",
                                            lineHeight: "1.25",
                                            display: "inline",
                                            fill: "#000",
                                            fillOpacity: "1",
                                            stroke: "none",
                                            strokeWidth: "0.93416977",
                                          }}
                                          xmlSpace="preserve"
                                        >
                                          <tspan
                                            style={{
                                              fontStyle: "normal",
                                              fontVariant: "normal",
                                              fontWeight: "normal",
                                              fontStretch: "normal",
                                              fontSize: "7.4083333px",
                                              fontFamily: "Calibri",
                                              fontVariantLigatures: "normal",
                                              fontVariantCaps: "normal",
                                              fontVariantNumeric: "normal",
                                              MozFontFeatureSettings: "normal",
                                              textAlign: "start",
                                              writingMode: "lr-tb",
                                              textAnchor: "start",
                                              strokeWidth: "0.93416977",
                                            }}
                                            y="15.273439"
                                            x="127.95478"
                                            id="tspan3664"
                                          >
                                            CRVENA TRIBINA
                                          </tspan>
                                        </text>
                                        <text
                                          id="text3666-1"
                                          y="62.029751"
                                          x="137.99696"
                                          style={{
                                            fontStyle: "normal",
                                            fontVariant: "normal",
                                            fontWeight: "normal",
                                            fontStretch: "normal",
                                            fontSize: "4.23333311",
                                            lineHeight: "1.25",
                                            textAnchor: "start",
                                            display: "inline",
                                            fill: "#000",
                                            fillOpacity: "1",
                                            stroke: "none",
                                            strokeWidth: "0,53829247",
                                          }}
                                          xmlSpace="preserve"
                                        >
                                          <tspan
                                            style={{
                                              // fontStyle: "normal",
                                              // fontVariant: "normal",
                                              // fontWeight: "normal",
                                              // fontStretch: "normal",
                                              // fontSize: "4.23333311",
                                              // fontFamily: "Calibri",
                                              // fontVariantLigatures: "normal",
                                              // fontVariantCaps: "normal",
                                              // fontVariantNumeric: "normal",
                                              // fontFeatureSettings: "normal",
                                              textAlign: "start",
                                              writingMode: "lr-tb",
                                              textAnchor: "start",
                                              strokeWidth: "0.53829247",
                                            }}
                                            y="64.029751"
                                            x="137.99696"
                                            id="tspan3664-2"
                                          >
                                            CRVENI TELESKOP
                                          </tspan>
                                        </text>
                                        <text
                                          transform="rotate(90)"
                                          id="text3666-1-0"
                                          y="-213.07617"
                                          x="86.835693"
                                          style={{
                                            fontStyle: "normal",
                                            fontVariant: "normal",
                                            fontWeight: "normal",
                                            fontStretch: "normal",
                                            fontSize: "4.23333311",
                                            lineHeight: "1.25",
                                            textAnchor: "start",
                                            display: "inline",
                                            fill: "#000",
                                            fillOpacity: "1",
                                            stroke: "none",
                                            strokeWidth: "0,53829247",
                                          }}
                                          xmlSpace="preserve"
                                        >
                                          <tspan
                                            y="-209.07617"
                                            x="86.835693"
                                            id="tspan3704"
                                            style={{
                                              strokeWidth: "0.53829247",
                                            }}
                                          >
                                            ZELENI TELESKOP
                                          </tspan>
                                        </text>
                                        <text
                                          transform="rotate(90)"
                                          id="text3666-2"
                                          y="-272.12524"
                                          x="76.857056"
                                          style={{
                                            fontStyle: "Normal",
                                            fontVariant: "normal",
                                            fontWeight: "normal",
                                            fontStretch: "normal",
                                            fontSize: "7.4083333px",
                                            lineHeight: "1.25",
                                            display: "inline",
                                            fill: "#000",
                                            fillOpacity: "1",
                                            stroke: "none",
                                            strokeWidth: "0.93416977",
                                          }}
                                          xmlSpace="preserve"
                                        >
                                          <tspan
                                            y="-272.12524"
                                            x="76.857056"
                                            id="tspan3724"
                                            style={{
                                              // fontStyle: "Normal",
                                              // fontVariant: "normal",
                                              // fontWeight: "normal",
                                              // fontStretch: "normal",
                                              // fontSize: "7.4083333px",
                                              lineHeight: "1.25",
                                              display: "inline",
                                              fill: "#000",
                                              fillOpacity: "1",
                                              stroke: "none",
                                              strokeWidth: "0.93416977",
                                            }}
                                          >
                                            ZELENA TRIBINA
                                          </tspan>
                                        </text>
                                        <text
                                          id="text3666-0"
                                          y="196.06094"
                                          x="130.17284"
                                          style={{
                                            fontStyle: "Normal",
                                            fontVariant: "normal",
                                            fontWeight: "normal",
                                            fontStretch: "normal",
                                            fontSize: "7.4083333px",
                                            lineHeight: "1.25",
                                            display: "inline",
                                            fill: "#000",
                                            fillOpacity: "1",
                                            stroke: "none",
                                            strokeWidth: "0.93416977",
                                          }}
                                          xmlSpace="preserve"
                                        >
                                          <tspan
                                            y="196.06094"
                                            x="130.17284"
                                            id="tspan3734"
                                            style={{
                                              // fontStyle: "Normal",
                                              // fontVariant: "normal",
                                              // fontWeight: "normal",
                                              // fontStretch: "normal",
                                              fontSize: "7.4083333px",
                                              lineHeight: "1.25",
                                              display: "inline",
                                              fill: "#000",
                                              fillOpacity: "1",
                                              stroke: "none",
                                              strokeWidth: "0.93416977",
                                            }}
                                          >
                                            PLAVA TRIBINA
                                          </tspan>
                                        </text>
                                        <text
                                          id="text3666-1-3"
                                          y="143.26892"
                                          x="139.20073"
                                          style={{
                                            fontStyle: "normal",
                                            fontVariant: "normal",
                                            fontWeight: "normal",
                                            fontStretch: "normal",
                                            fontSize: "4.23333311",
                                            lineHeight: "1.25",
                                            textAnchor: "start",
                                            display: "inline",
                                            fill: "#000",
                                            fillOpacity: "1",
                                            stroke: "none",
                                            strokeWidth: "0,53829247",
                                          }}
                                          xmlSpace="preserve"
                                        >
                                          <tspan
                                            y="143.26892"
                                            x="139.20073"
                                            id="tspan3754"
                                            style={{
                                              strokeWidth: "0.53829247",
                                            }}
                                          >
                                            PLAVI TELESKOP
                                          </tspan>
                                        </text>
                                        <text
                                          transform="rotate(-90)"
                                          id="text3666-1-5"
                                          y="93.752747"
                                          x="-114.43527"
                                          style={{
                                            fontStyle: "normal",
                                            fontVariant: "normal",
                                            fontWeight: "normal",
                                            fontStretch: "normal",
                                            fontSize: "4.23333311",
                                            lineHeight: "1.25",
                                            textAnchor: "start",
                                            display: "inline",
                                            fill: "#000",
                                            fillOpacity: "1",
                                            stroke: "none",
                                            strokeWidth: "0,53829247",
                                          }}
                                          xmlSpace="preserve"
                                        >
                                          <tspan
                                            y="97.752747"
                                            x="-118.43527"
                                            id="tspan3764"
                                            style={{
                                              strokeWidth: "0.53829247",
                                            }}
                                          >
                                            ŽUTI TELESKOP
                                          </tspan>
                                        </text>
                                        <text
                                          transform="rotate(-90)"
                                          id="text3666-7"
                                          y="28.9776"
                                          x="-122.5344"
                                          style={{
                                            fontStyle: "Normal",
                                            fontVariant: "normal",
                                            fontWeight: "normal",
                                            fontStretch: "normal",
                                            fontSize: "7.4083333px",
                                            lineHeight: "1.25",
                                            display: "inline",
                                            fill: "#000",
                                            fillOpacity: "1",
                                            stroke: "none",
                                            strokeWidth: "0.93416977",
                                          }}
                                          xmlSpace="preserve"
                                        >
                                          <tspan
                                            y="28.9776"
                                            x="-122.5344"
                                            id="tspan3784"
                                            style={{
                                              fontStyle: "Normal",
                                              fontVariant: "normal",
                                              fontWeight: "normal",
                                              fontStretch: "normal",
                                              fontSize: "7.4083333px",
                                              lineHeight: "1.25",
                                              display: "inline",
                                              fill: "#000",
                                              fillOpacity: "1",
                                              stroke: "none",
                                              strokeWidth: "0.93416977",
                                            }}
                                          >
                                            ŽUTA TRIBINA
                                          </tspan>
                                        </text>
                                      </g>
                                      <g
                                        id="pozornica"
                                        className="svg_pozornica"
                                      >
                                        {" "}
                                        <use
                                          transform="translate(31.160289,-15.435707)"
                                          height="100%"
                                          width="100%"
                                          id="use3265-3-5-6-44-9"
                                          xlinkHref="#g11803-5-6-3-54-6-6"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <rect
                                          y="70.465004"
                                          x="101.24259"
                                          height="61.67979"
                                          width="104.03716"
                                          id="rect2163-4-2-3-4"
                                          style={{
                                            display: "inline",
                                            opacity: "1",
                                            fill: "#3b71ff",
                                            fillOpacity: "1",
                                            stroke: "#3b71ff",
                                            strokeWidth: "0.16704851",
                                            strokeLinecap: "butt",
                                            strokeLinejoin: "round",
                                            strokeMiterlimit: "4",
                                            strokeDasharray: "none",
                                            strokeDashoffset: "0",
                                            strokeOpacity: "0.97254902",
                                            paintOrder: "markers fill stroke",
                                          }}
                                        ></rect>
                                        <use
                                          transform="translate(-46.740418,-38.716998)"
                                          id="use3267-4-3-6-1-7"
                                          height="100%"
                                          width="100%"
                                          xlinkHref="#g11467-6-6-4-9-3-5-9"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <use
                                          transform="matrix(-1,0,0,1,275.969,-38.665844)"
                                          height="100%"
                                          width="100%"
                                          id="use3265-3-5-6-4-0-7-5-7-8-9-2"
                                          xlinkHref="#g11803-5-6-3-54-6-6"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <use
                                          transform="translate(31.16029,-30.92249)"
                                          height="100%"
                                          width="100%"
                                          id="use3265-3-5-6-44-9-4"
                                          xlinkHref="#g11803-5-6-3-54-6-6"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <g
                                          transform="matrix(-0.42502814,0,0,-0.41969027,374.09479,318.81635)"
                                          id="g11803-5-6-3-54-6-6"
                                          style={{
                                            stroke: "#ecbe7e",
                                            strokeOpacity: "0.75686275",
                                          }}
                                        >
                                          <path
                                            id="rect2290-3-4-0-3-4-5-5-6-5-8-8-9-85-9"
                                            d="M -478.94006,-491.36758 H -469.65408 V -489.07653 H -478.94006 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="matrix(0,-1,-1,0,0,0)"
                                          ></path>
                                          <path
                                            id="rect2290-5-7-5-8-0-6-9-5-7-5-5-3-9-3-5"
                                            d="M -478.94006,-489.07657 H -469.65408 V -486.78551 H -478.94006 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="matrix(0,-1,-1,0,0,0)"
                                          ></path>
                                          <path
                                            id="rect2290-3-1-5-2-3-2-61-00-35-6-5-5-0-9-4"
                                            d="M 460.36798,-491.36758 H 469.65397 V -489.07653 H 460.36798 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="rotate(90)"
                                          ></path>
                                          <path
                                            id="rect2290-5-7-0-0-3-9-5-1-3-8-5-7-2-2-5-7"
                                            d="M 460.36798,-489.07657 H 469.65397 V -486.78551 H 460.36798 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="rotate(90)"
                                          ></path>
                                          <path
                                            id="rect2290-3-4-0-3-4-5-6-0-8-1-3-9-4-6-2"
                                            d="M -478.94006,-495.94968 H -469.65408 V -493.65862 H -478.94006 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="matrix(0,-1,-1,0,0,0)"
                                          ></path>
                                          <path
                                            id="rect2290-5-7-5-8-0-6-9-0-9-6-5-4-4-8-6-8"
                                            d="M -478.94006,-493.65866 H -469.65408 V -491.36761 H -478.94006 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="matrix(0,-1,-1,0,0,0)"
                                          ></path>
                                          <path
                                            id="rect2290-3-1-5-2-3-2-61-0-6-0-0-3-4-21-8-0"
                                            d="M 460.36798,-495.94968 H 469.65397 V -493.65862 H 460.36798 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="rotate(90)"
                                          ></path>
                                          <path
                                            id="rect2290-5-7-0-0-3-9-5-1-5-3-0-3-7-5-9-7-1"
                                            d="M 460.36798,-493.65866 H 469.65397 V -491.36761 H 460.36798 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="rotate(90)"
                                          ></path>
                                          <path
                                            id="rect2290-3-4-0-3-4-5-6-1-3-2-05-3-6-2-3-4"
                                            d="M -478.94006,-500.53177 H -469.65408 V -498.24071 H -478.94006 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="matrix(0,-1,-1,0,0,0)"
                                          ></path>
                                          <path
                                            id="rect2290-5-7-5-8-0-6-9-0-4-6-2-1-8-2-9-1-5"
                                            d="M -478.94006,-498.24075 H -469.65408 V -495.9497 H -478.94006 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="matrix(0,-1,-1,0,0,0)"
                                          ></path>
                                          <path
                                            id="rect2290-3-1-5-2-3-2-61-0-7-2-5-4-4-3-0-7-0"
                                            d="M 460.36792,-500.53177 H 469.6539 V -498.24071 H 460.36792 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="rotate(90)"
                                          ></path>
                                          <path
                                            id="rect2290-5-7-0-0-3-9-5-1-5-2-1-1-6-3-5-0-0-4"
                                            d="M 460.36792,-498.24075 H 469.6539 V -495.9497 H 460.36792 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="rotate(90)"
                                          ></path>
                                          <path
                                            id="rect2290-3-4-0-3-4-5-6-1-9-5-6-6-5-5-4-6-0"
                                            d="M -478.94006,-486.78549 H -469.65408 V -484.49444 H -478.94006 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="matrix(0,-1,-1,0,0,0)"
                                          ></path>
                                          <path
                                            id="rect2290-5-7-5-8-0-6-9-0-4-7-3-7-8-1-2-9-6-1"
                                            d="M -478.94006,-484.49448 H -469.65408 V -482.20342 H -478.94006 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="matrix(0,-1,-1,0,0,0)"
                                          ></path>
                                          <path
                                            id="rect2290-3-1-5-2-3-2-61-0-7-6-7-7-2-6-8-0-1-7"
                                            d="M 460.36792,-486.78549 H 469.6539 V -484.49444 H 460.36792 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="rotate(90)"
                                          ></path>
                                          <path
                                            id="rect2290-5-7-0-0-3-9-5-1-5-2-0-5-4-3-4-6-0-7-2"
                                            d="M 460.36792,-484.49448 H 469.6539 V -482.20342 H 460.36792 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="rotate(90)"
                                          ></path>
                                          <path
                                            id="rect2290-3-4-0-3-4-5-5-6-8-4-0-5-6-34-7"
                                            d="M -478.94006,-509.69595 H -469.65408 V -507.4049 H -478.94006 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="matrix(0,-1,-1,0,0,0)"
                                          ></path>
                                          <path
                                            id="rect2290-5-7-5-8-0-6-9-5-7-7-2-3-8-3-5-8"
                                            d="M -478.94006,-507.40494 H -469.65408 V -505.11388 H -478.94006 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="matrix(0,-1,-1,0,0,0)"
                                          ></path>
                                          <path
                                            id="rect2290-3-1-5-2-3-2-61-00-35-0-8-0-8-9-5-4"
                                            d="M 460.36798,-509.69595 H 469.65397 V -507.4049 H 460.36798 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="rotate(90)"
                                          ></path>
                                          <path
                                            id="rect2290-5-7-0-0-3-9-5-1-3-8-7-3-7-6-6-9-0"
                                            d="M 460.36798,-507.40494 H 469.65397 V -505.11388 H 460.36798 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="rotate(90)"
                                          ></path>
                                          <path
                                            id="rect2290-3-4-0-3-4-5-6-0-8-7-5-6-1-9-32-0"
                                            d="M -478.94006,-514.27808 H -469.65408 V -511.98702 H -478.94006 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="matrix(0,-1,-1,0,0,0)"
                                          ></path>
                                          <path
                                            id="rect2290-5-7-5-8-0-6-9-0-9-6-2-4-6-8-8-4-3"
                                            d="M -478.94006,-511.98703 H -469.65408 V -509.69597 H -478.94006 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="matrix(0,-1,-1,0,0,0)"
                                          ></path>
                                          <path
                                            id="rect2290-3-1-5-2-3-2-61-0-6-0-6-5-7-5-2-5-0"
                                            d="M 460.36798,-514.27808 H 469.65397 V -511.98702 H 460.36798 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="rotate(90)"
                                          ></path>
                                          <path
                                            id="rect2290-5-7-0-0-3-9-5-1-5-3-0-7-8-1-7-3-6-5"
                                            d="M 460.36798,-511.98703 H 469.65397 V -509.69597 H 460.36798 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="rotate(90)"
                                          ></path>
                                          <path
                                            id="rect2290-3-4-0-3-4-5-6-1-3-2-0-3-1-3-47-8-2"
                                            d="M -478.94006,-518.86017 H -469.65408 V -516.56911 H -478.94006 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="matrix(0,-1,-1,0,0,0)"
                                          ></path>
                                          <path
                                            id="rect2290-5-7-5-8-0-6-9-0-4-6-2-0-8-8-1-9-00-9"
                                            d="M -478.94006,-516.56915 H -469.65408 V -514.2781 H -478.94006 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="matrix(0,-1,-1,0,0,0)"
                                          ></path>
                                          <path
                                            id="rect2290-3-1-5-2-3-2-61-0-7-2-5-9-9-0-6-6-0-7"
                                            d="M 460.36792,-518.86017 H 469.6539 V -516.56911 H 460.36792 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="rotate(90)"
                                          ></path>
                                          <path
                                            id="rect2290-5-7-0-0-3-9-5-1-5-2-1-1-7-7-2-6-8-4-3"
                                            d="M 460.36792,-516.56915 H 469.6539 V -514.2781 H 460.36792 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="rotate(90)"
                                          ></path>
                                          <path
                                            id="rect2290-3-4-0-3-4-5-6-1-9-5-6-7-6-1-9-8-3-4"
                                            d="M -478.94006,-505.11386 H -469.65408 V -502.82281 H -478.94006 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="matrix(0,-1,-1,0,0,0)"
                                          ></path>
                                          <path
                                            id="rect2290-5-7-5-8-0-6-9-0-4-7-3-7-7-9-9-4-51-4-4"
                                            d="M -478.94006,-502.82285 H -469.65408 V -500.53179 H -478.94006 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="matrix(0,-1,-1,0,0,0)"
                                          ></path>
                                          <path
                                            id="rect2290-3-1-5-2-3-2-61-0-7-6-7-7-1-4-9-0-0-0-8"
                                            d="M 460.36792,-505.11386 H 469.6539 V -502.82281 H 460.36792 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="rotate(90)"
                                          ></path>
                                          <path
                                            id="rect2290-5-7-0-0-3-9-5-1-5-2-0-5-4-4-6-0-4-0-13-7"
                                            d="M 460.36792,-502.82285 H 469.6539 V -500.53179 H 460.36792 Z"
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            transform="rotate(90)"
                                          ></path>
                                        </g>
                                        <g
                                          transform="matrix(0.41945056,0,0,0.41969027,-45.519714,-63.901933)"
                                          id="g11467-6-6-4-9-3-5-9"
                                          style={{
                                            stroke: "#ecbe7e",
                                            strokeOpacity: "0.75686275",
                                          }}
                                        >
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-3-4-0-3-4-5-1-7-1-5-9-8-7"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="-530.34753"
                                            y="-442.3743"
                                            transform="scale(-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-5-7-5-8-0-6-9-2-4-6-5-2-0-3"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="-530.34753"
                                            y="-440.08325"
                                            transform="scale(-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-3-1-5-2-3-2-61-9-5-4-1-4-4-2"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="511.77548"
                                            y="-442.3743"
                                            transform="scale(1,-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-5-7-0-0-3-9-5-1-99-3-1-6-3-7-9"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="511.77548"
                                            y="-440.08325"
                                            transform="scale(1,-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-3-4-0-3-4-5-6-16-9-2-7-6-9-1"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="-530.34753"
                                            y="-446.95639"
                                            transform="scale(-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-5-7-5-8-0-6-9-0-2-7-1-6-4-9-7"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="-530.34753"
                                            y="-444.66534"
                                            transform="scale(-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-3-1-5-2-3-2-61-0-1-9-0-9-9-2-3"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="511.77545"
                                            y="-446.95639"
                                            transform="scale(1,-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-5-7-0-0-3-9-5-1-5-30-9-6-4-7-7-1"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="511.77545"
                                            y="-444.66534"
                                            transform="scale(1,-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-3-4-0-3-4-5-6-1-82-5-8-6-6-4-4"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="-530.34753"
                                            y="-451.53848"
                                            transform="scale(-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-5-7-5-8-0-6-9-0-4-07-6-7-4-1-6-2"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="-530.34753"
                                            y="-449.24744"
                                            transform="scale(-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-3-1-5-2-3-2-61-0-7-40-2-7-8-5-4-3"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="511.77539"
                                            y="-451.53848"
                                            transform="scale(1,-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-5-7-0-0-3-9-5-1-5-2-6-8-1-9-6-2-6"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="511.77539"
                                            y="-449.24744"
                                            transform="scale(1,-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-3-4-0-3-4-5-6-1-9-50-4-4-9-3-8-3"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="-530.34753"
                                            y="-437.79221"
                                            transform="scale(-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-5-7-5-8-0-6-9-0-4-7-4-5-5-8-7-8-5"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="-530.34753"
                                            y="-435.50116"
                                            transform="scale(-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-3-1-5-2-3-2-61-0-7-6-2-7-3-3-9-4-3"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="511.77536"
                                            y="-437.79221"
                                            transform="scale(1,-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-5-7-0-0-3-9-5-1-5-2-0-6-6-5-7-5-0-5"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="511.77536"
                                            y="-435.50116"
                                            transform="scale(1,-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-3-4-0-3-4-5-5-63-5-8-5-6-7-2"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="-548.91962"
                                            y="-442.3743"
                                            transform="scale(-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-5-7-5-8-0-6-9-5-5-5-6-3-0-2-5"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="-548.91962"
                                            y="-440.08325"
                                            transform="scale(-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-3-1-5-2-3-2-61-00-3-9-8-5-7-9-4"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="530.34753"
                                            y="-442.3743"
                                            transform="scale(1,-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-5-7-0-0-3-9-5-1-3-83-4-4-1-2-8-0"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="530.34753"
                                            y="-440.08325"
                                            transform="scale(1,-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-3-4-0-3-4-5-6-0-6-5-1-3-0-8-5"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="-548.91962"
                                            y="-446.95639"
                                            transform="scale(-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-5-7-5-8-0-6-9-0-9-7-7-7-8-7-1-8"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="-548.91962"
                                            y="-444.66534"
                                            transform="scale(-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-3-1-5-2-3-2-61-0-6-1-1-7-0-3-3-3"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="530.34753"
                                            y="-446.95639"
                                            transform="scale(1,-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-5-7-0-0-3-9-5-1-5-3-7-7-9-7-2-7-7"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="530.34753"
                                            y="-444.66534"
                                            transform="scale(1,-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-3-4-0-3-4-5-6-1-3-1-6-2-4-6-5-4"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="-548.91962"
                                            y="-451.53848"
                                            transform="scale(-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-5-7-5-8-0-6-9-0-4-6-7-8-2-7-2-5-8"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="-548.91962"
                                            y="-449.24744"
                                            transform="scale(-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-3-1-5-2-3-2-61-0-7-2-8-2-0-4-9-9-9"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="530.34747"
                                            y="-451.53848"
                                            transform="scale(1,-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-5-7-0-0-3-9-5-1-5-2-1-5-7-5-5-9-1-9"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="530.34747"
                                            y="-449.24744"
                                            transform="scale(1,-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-3-4-0-3-4-5-6-1-9-5-1-0-3-9-3-5-2"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="-548.91962"
                                            y="-437.79221"
                                            transform="scale(-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-5-7-5-8-0-6-9-0-4-7-3-1-4-3-0-0-0-2"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="-548.91962"
                                            y="-435.50116"
                                            transform="scale(-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#e0a864",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              strokeOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-3-1-5-2-3-2-61-0-7-6-7-2-0-5-0-1-6-6"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="530.34747"
                                            y="-437.79221"
                                            transform="scale(1,-1)"
                                          ></rect>
                                          <rect
                                            style={{
                                              opacity: "1",
                                              fill: "#eab871",
                                              fillOpacity: "1",
                                              stroke: "#ecbe7e",
                                              strokeWidth: "0.16019525",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "0",
                                              stopOpacity: "0.75686275",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="rect2290-5-7-0-0-3-9-5-1-5-2-0-5-3-4-2-4-9-4-2"
                                            width="9.285985"
                                            height="2.2910552"
                                            x="530.34747"
                                            y="-435.50116"
                                            transform="scale(1,-1)"
                                          ></rect>
                                        </g>
                                        <use
                                          transform="translate(-2.1263306e-5,-30.922467)"
                                          height="100%"
                                          width="100%"
                                          id="use3265-3-5-6"
                                          xlinkHref="#g11803-5-6-3-54-6-6"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <use
                                          transform="translate(-15.580183,-38.716975)"
                                          id="use3267-4-3-6-1"
                                          height="100%"
                                          width="100%"
                                          xlinkHref="#g11467-6-6-4-9-3-5-9"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <use
                                          transform="matrix(-1,0,0,1,338.2895,-23.230115)"
                                          id="use3267-4-3"
                                          height="100%"
                                          width="100%"
                                          xlinkHref="#g11467-6-6-4-9-3-5-9"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <use
                                          transform="translate(-2.0491718e-5,-15.486785)"
                                          id="use3267-4"
                                          height="100%"
                                          width="100%"
                                          xlinkHref="#g11467-6-6-4-9-3-5-9"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <use
                                          transform="matrix(-1,0,0,1,338.28956,-7.7433548)"
                                          id="use3267"
                                          height="100%"
                                          width="100%"
                                          xlinkHref="#g11467-6-6-4-9-3-5-9"
                                          y="0"
                                          x="0"
                                        ></use>
                                        <use
                                          transform="matrix(-1,0,0,1,338.28953,-7.6922768)"
                                          height="100%"
                                          width="100%"
                                          id="use3265"
                                          xlinkHref="#g11803-5-6-3-54-6-6"
                                          y="0"
                                          x="0"
                                        ></use>
                                        <use
                                          transform="translate(9.5082816e-6,-15.435707)"
                                          height="100%"
                                          width="100%"
                                          id="use3265-3"
                                          xlinkHref="#g11803-5-6-3-54-6-6"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <use
                                          transform="translate(-15.580165,-38.665822)"
                                          height="100%"
                                          width="100%"
                                          id="use3265-3-5-6-4-0"
                                          xlinkHref="#g11803-5-6-3-54-6-6"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <use
                                          transform="matrix(-1,0,0,1,322.70936,-30.973545)"
                                          id="use3267-4-3-6-1-7-1"
                                          height="100%"
                                          width="100%"
                                          xlinkHref="#g11467-6-6-4-9-3-5-9"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <use
                                          transform="matrix(-1,0,0,1,322.70931,-15.48676)"
                                          id="use3267-4-3-6-1-7-1-1-2"
                                          height="100%"
                                          width="100%"
                                          xlinkHref="#g11467-6-6-4-9-3-5-9"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <use
                                          transform="translate(-15.580213,-23.179037)"
                                          height="100%"
                                          width="100%"
                                          id="use3265-3-5-6-4-0-7-5"
                                          xlinkHref="#g11803-5-6-3-54-6-6"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <use
                                          transform="translate(-15.580263,-7.6922522)"
                                          height="100%"
                                          width="100%"
                                          id="use3265-3-5-6-4-0-7-5-7-8"
                                          xlinkHref="#g11803-5-6-3-54-6-6"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <use
                                          transform="matrix(-1,0,0,1,322.70926,2.464366e-5)"
                                          id="use3267-4-3-6-1-7-1-1-2-0-8"
                                          height="100%"
                                          width="100%"
                                          xlinkHref="#g11467-6-6-4-9-3-5-9"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <path
                                          id="path1951-94-1"
                                          d="M 153.56463,78.980454 V 125.60434"
                                          style={{
                                            display: "inline",
                                            fill: "none",
                                            stroke: "#ffffff",
                                            strokeWidth: "0.32345411",
                                            strokeLinecap: "butt",
                                            strokeLinejoin: "miter",
                                            strokeMiterlimit: "4",
                                            strokeDasharray: "none",
                                            stopOpacity: "1",
                                          }}
                                        ></path>
                                        <use
                                          transform="translate(15.537331,-7.7984494)"
                                          id="use3267-4-3-6-1-3"
                                          height="100%"
                                          width="100%"
                                          xlinkHref="#g11467-6-6-4-9-3-5-9"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <use
                                          transform="translate(15.580128,-23.230213)"
                                          id="use3267-4-3-6-1-3-2"
                                          height="100%"
                                          width="100%"
                                          xlinkHref="#g11467-6-6-4-9-3-5-9"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <use
                                          transform="matrix(-1,0,0,1,338.28947,-23.179037)"
                                          height="100%"
                                          width="100%"
                                          id="use3265-3-5"
                                          xlinkHref="#g11803-5-6-3-54-6-6"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <path
                                          id="path2030-0-5-2-0-3"
                                          d="M 200.08335,110.37485 H 177.99824 V 95.348555 H 200.08335"
                                          style={{
                                            display: "inline",
                                            fill: "#3b71ff",
                                            fillOpacity: "1",
                                            stroke: "#ffffff",
                                            strokeWidth: "0.35646945",
                                            strokeLinecap: "butt",
                                            strokeLinejoin: "miter",
                                            strokeMiterlimit: "4",
                                            strokeDasharray: "none",
                                            stopOpacity: "1",
                                          }}
                                        ></path>
                                        <path
                                          id="path1953-0-2-5-3-7-9-8"
                                          d="M 178.04208,97.206009 A 5.5742634,5.5742634 0 0 0 177.92126,97.210146 V 108.34822 A 5.5742634,5.5742634 0 0 0 178.04208,108.35415 A 5.5742634,5.5742634 0 0 0 183.61646,102.77978 A 5.5742634,5.5742634 0 0 0 178.04208,97.206009 Z"
                                          style={{
                                            display: "inline",
                                            opacity: "1",
                                            fill: "#3b71ff",
                                            fillOpacity: "1",
                                            stroke: "#ffffff",
                                            strokeWidth: "0.32345411",
                                            strokeLinecap: "butt",
                                            strokeLinejoin: "round",
                                            strokeMiterlimit: "4",
                                            strokeDasharray:
                                              "1.29381645, 1.29381645",
                                            strokeDashoffset: "2.24000001",
                                            stopOpacity: "1",
                                            paintOrder: "markers fill stroke",
                                          }}
                                        ></path>
                                        <use
                                          transform="translate(15.580129,-38.716996)"
                                          id="use3267-4-3-6-1-3-2-0"
                                          height="100%"
                                          width="100%"
                                          xlinkHref="#g11467-6-6-4-9-3-5-9"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <use
                                          transform="translate(15.58007,-38.665797)"
                                          height="100%"
                                          width="100%"
                                          id="use3265-3-5-6-4"
                                          xlinkHref="#g11803-5-6-3-54-6-6"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <use
                                          transform="translate(31.117493,-0.00394336)"
                                          height="100%"
                                          width="100%"
                                          id="use3265-3-5-6-44"
                                          xlinkHref="#g11803-5-6-3-54-6-6"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <use
                                          transform="translate(-4.1263306e-5,-30.973545)"
                                          id="use3267-4-3-6"
                                          height="100%"
                                          width="100%"
                                          xlinkHref="#g11467-6-6-4-9-3-5-9"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <path
                                          id="path2096-4-2-3-9-8"
                                          d="M 195.09978,82.139345 H 184.71028 C 165.01079,87.320197 162.83232,116.35702 184.71028,122.58797 H 195.09978"
                                          style={{
                                            display: "inline",
                                            fill: "none",
                                            stroke: "#fefefe",
                                            strokeWidth: "0.32345411",
                                            strokeLinecap: "butt",
                                            strokeLinejoin: "miter",
                                            strokeMiterlimit: "4",
                                            strokeDasharray: "none",
                                            strokeOpacity: "1",
                                          }}
                                        ></path>
                                        <text
                                          transform="scale(0.86917455,1.1505169)"
                                          id="text7965-3-6-6"
                                          y="67.134125"
                                          x="144.96402"
                                          style={{
                                            fontStyle: "normal",
                                            fontVariant: "normal",
                                            fontWeight: "normal",
                                            fontStretch: "normal",
                                            fontSize: "3.58490062px",
                                            lineHeight: "1.25",
                                            fontFamily: "sans-serif",
                                            fontVariantCaps: "normal",
                                            fontVariantNumeric: "normal",
                                            fontFeatureSettings: "normal",
                                            textAlign: "start",
                                            writingMode: "lr-tb",
                                            textAnchor: "start",
                                            stroke: "none",
                                            fillOpacity: "1",
                                            display: "inline",
                                            strokeWidth: "0.07468545",
                                            wordSpacing: "0px",
                                            latterSpacing: "0px",
                                          }}
                                          xmlSpace="preserve"
                                        >
                                          <tspan
                                            style={{
                                              fill: "#f6f6f6",
                                              fillOpacity: "1",
                                              strokeWidth: "0.0768545",
                                            }}
                                            y="67.134125"
                                            x="144.96402"
                                            id="tspan7963-0-3-9"
                                          >
                                            <tspan
                                              id="tspan7967-2-1-7"
                                              style={{
                                                // fontStyle: "normal",
                                                // fontVariant: "normal",
                                                // fontWeight: "bold",
                                                // fontStretch: "normal",
                                                // fontSize: "3.58488321px",
                                                // fontFamily: "sans-serif",
                                                // fontVariantCaps: "normal",
                                                // fontVariantNumeric: "normal",
                                                // fontFeatureSettings: "normal",
                                                textAlign: "start",
                                                writingMode: "lr-tb",
                                                textAnchor: "start",
                                                strokeWidth: "0.07468545",
                                              }}
                                            >
                                              KC DRAŽEN PETROVIĆ - ZAGREB
                                            </tspan>
                                          </tspan>
                                        </text>
                                        <path
                                          id="path1953-0-2-5-3-7-54-9-3"
                                          d="M 177.92126,97.210146 A 5.5742634,5.5742634 0 0 1 178.04208,97.214295 V 108.35238 A 5.5742634,5.5742634 0 0 1 177.92126,108.3583 A 5.5742634,5.5742634 0 0 1 172.34688,102.78393 A 5.5742634,5.5742634 0 0 1 177.92126,97.210146 Z"
                                          style={{
                                            display: "inline",
                                            opacity: "1",
                                            fill: "#3b71ff",
                                            fillOpacity: "1",
                                            stroke: "white",
                                            strokeWidth: "0.32345411",
                                            strokeLinecap: "butt",
                                            strokeLinejoin: "round",
                                            strokeMiterlimit: "4",
                                            strokeDasharray: "none",
                                            strokeDashoffset: "0",
                                            strokeOpacity: "1",
                                            paintOrder: "markers fill stroke",
                                          }}
                                        ></path>
                                        <path
                                          id="path8060-75-3"
                                          d="M 195.09978,122.58797 H 200.22784"
                                          style={{
                                            display: "inline",
                                            fill: "none",
                                            stroke: "white",
                                            strokeWidth: "0.30323824px",
                                            strokeLinecap: "butt",
                                            strokeLinejoin: "miter",
                                            strokeOpacity: "1",
                                          }}
                                        ></path>
                                        <path
                                          id="path8060-6-4-3"
                                          d="M 195.09978,82.139345 H 200.22784"
                                          style={{
                                            display: "inline",
                                            fill: "none",
                                            stroke: "white",
                                            strokeWidth: "0.30323824px",
                                            strokeLinecap: "butt",
                                            strokeLinejoin: "miter",
                                            strokeOpacity: "1",
                                          }}
                                        ></path>
                                        <use
                                          transform="matrix(-1,0,0,1,291.54922,-15.486783)"
                                          id="use3267-4-3-6-1-7-1-1-2-0-8-3-5"
                                          height="100%"
                                          width="100%"
                                          xlinkHref="#g11467-6-6-4-9-3-5-9"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <use
                                          transform="translate(-46.740503,-7.7434282)"
                                          id="use3267-4-3-6-1-7-1-1-2-0"
                                          height="100%"
                                          width="100%"
                                          xlinkHref="#g11467-6-6-4-9-3-5-9"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <use
                                          transform="matrix(-1,0,0,1,275.96905,-23.179059)"
                                          height="100%"
                                          width="100%"
                                          id="use3265-3-5-6-4-0-7-5-7-8-9-2-3"
                                          xlinkHref="#g11803-5-6-3-54-6-6"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <use
                                          transform="matrix(-1,0,0,1,291.54907,-15.435584)"
                                          height="100%"
                                          width="100%"
                                          id="use3265-3-5-6-4-0-7-5-7"
                                          xlinkHref="#g11803-5-6-3-54-6-6"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <use
                                          transform="translate(-46.740453,-23.230213)"
                                          id="use3267-4-3-6-1-7-1-1"
                                          height="100%"
                                          width="100%"
                                          xlinkHref="#g11467-6-6-4-9-3-5-9"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <path
                                          id="path2030-0-5-2-3-4-3"
                                          d="M 106.87,109.99771 H 128.9551 V 94.971416 H 106.87"
                                          style={{
                                            display: "inline",
                                            fill: "#3b71ff",
                                            fillOpacity: "1",
                                            stroke: "#ffffff",
                                            strokeWidth: "0.35646945",
                                            strokeLinecap: "butt",
                                            strokeLinejoin: "miter",
                                            strokeMiterlimit: "4",
                                            strokeDasharray: "none",
                                            stopOpacity: "1",
                                          }}
                                        ></path>
                                        <path
                                          id="path1953-0-2-5-3-7-6-6-0"
                                          d="M 128.80121,97.201836 A 5.5742634,5.5742634 0 0 1 128.92203,97.205973 V 108.34406 A 5.5742634,5.5742634 0 0 1 128.80121,108.34998 A 5.5742634,5.5742634 0 0 1 123.22683,102.77562 A 5.5742634,5.5742634 0 0 1 128.80121,97.201836 Z"
                                          style={{
                                            display: "inline",
                                            opacity: "1",
                                            fill: "#3b71ff",
                                            fillOpacity: "1",
                                            stroke: "#ffffff",
                                            strokeWidth: "0.32345411",
                                            strokeLinecap: "butt",
                                            strokeLinejoin: "round",
                                            strokeMiterlimit: "4",
                                            strokeDasharray:
                                              "1.29381646 , 1.29381646",
                                            strokeDashoffset: "2.24000001",
                                            stopOpacity: "1",
                                            paintOrder: "markers fill stroke",
                                          }}
                                        ></path>
                                        <path
                                          id="path1953-0-2-5-3-7-54-4-6-4"
                                          d="M 129.04284,97.201824 A 5.5742634,5.5742634 0 0 0 128.92203,97.205973 V 108.34406 A 5.5742634,5.5742634 0 0 0 129.04284,108.34997 A 5.5742634,5.5742634 0 0 0 134.61722,102.7756 A 5.5742634,5.5742634 0 0 0 129.04284,97.201824 Z"
                                          style={{
                                            display: "inline",
                                            opacity: "1",
                                            fill: "#3b71ff",
                                            fillOpacity: "1",
                                            stroke: "white",
                                            strokeWidth: "0.32345411",
                                            strokeLinecap: "butt",
                                            strokeLinejoin: "round",
                                            strokeMiterlimit: "4",
                                            strokeDasharray: "none",
                                            strokeDashoffset: "0",
                                            strokeOpacity: "1",
                                            paintOrder: "markers fill stroke",
                                          }}
                                        ></path>
                                        <use
                                          transform="matrix(-1,0,0,1,291.54927,8.007066e-7)"
                                          id="use3267-4-3-6-1-7-1-1-2-0-8-3-5-3"
                                          height="100%"
                                          width="100%"
                                          xlinkHref="#g11467-6-6-4-9-3-5-9"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <path
                                          id="path8060-7-9-0"
                                          d="M 111.86433,122.58794 H 106.73627"
                                          style={{
                                            display: "inline",
                                            fill: "none",
                                            stroke: "white",
                                            strokeWidth: "0.30323824px",
                                            strokeLinecap: "butt",
                                            strokeLinejoin: "miter",
                                            strokeOpacity: "1",
                                          }}
                                        ></path>
                                        <path
                                          id="path8060-6-9-9-4"
                                          d="M 111.86433,82.139297 H 106.73627"
                                          style={{
                                            display: "inline",
                                            fill: "none",
                                            stroke: "white",
                                            strokeWidth: "0.30323824px",
                                            strokeLinecap: "butt",
                                            strokeLinejoin: "miter",
                                            strokeOpacity: "1",
                                          }}
                                        ></path>
                                        <use
                                          transform="matrix(-1,0,0,1,291.54902,0.05120054)"
                                          height="100%"
                                          width="100%"
                                          id="use3265-3-5-6-4-0-7-5-7-8-9"
                                          xlinkHref="#g11803-5-6-3-54-6-6"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <use
                                          transform="matrix(-1,0,0,1,291.5491,-30.922369)"
                                          height="100%"
                                          width="100%"
                                          id="use3265-3-5-6-4-0-7"
                                          xlinkHref="#g11803-5-6-3-54-6-6"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <path
                                          id="path2096-4-2-3-7-8-6"
                                          d="M 111.86433,82.1393 H 122.25383 C 141.95331,87.320149 144.13179,116.35697 122.25383,122.58794 H 111.86433"
                                          style={{
                                            display: "inline",
                                            fill: "none",
                                            stroke: "#fefefe",
                                            strokeWidth: "0.32345411",
                                            strokeLinecap: "butt",
                                            strokeLinejoin: "miter",
                                            strokeMiterlimit: "4",
                                            strokeDasharray: "none",
                                            strokeOpacity: "1",
                                          }}
                                        ></path>
                                        <image
                                          width="10.101075"
                                          height="11.086546"
                                          preserveAspectRatio="none"
                                          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAAC0CAYAAAAaY4faAAAABGdBTUEAALGPC/xhBQAAAAlwSFlz AAAOwgAADsIBFShKgAAAABl0RVh0U29mdHdhcmUAcGFpbnQubmV0IDQuMC4yMfEgaZUAADYNSURB VHhe7Z15nBTF3caXa9nlvgRkuQ9BblQEuUTkRhDlWO5LRRDwCK/xQC7vAxRUwAPw4AZFoxJ9NZqI USJqDBo10STGHG9iEnOZ06j1Pk/11Ez37G9mu6t7egfiH98PO8NMV3XV0/V76lfVPQVKqTIUTNjw FcFoCfqDSWARWAk2gJ3gADgIXgPvgB+DHyXg3+8C/h8/8zTYBTaBVWAJKAUDQBtQCUjlHzt8JchA HAcGgtlgHXgefAD+DFSO+StgWS+Cu8BccDpoAqS6Hp18JciscOQbA9YDiu+3QBJLRfI78B3AEXk8 aA2kczk6+EqQHorBYHADeA78C0giyGc+A98Gt4BhoCaQzjU/+UqQG6qDc8Hd4BdA6uSjmV+De8EU UAtIbZA//BcLkpMQivBDIHXkscgvwX2AUUBqk4rnv0yQnABcBg4BqcP+m+DM/ipwPJDaqmL4LxFk b3AP+BOQOicCNqqCiWSTw6R7VUHpFlUw9QFVMO0hVTB9G9iuCmbsADsT8G+8x//jZ/hZfmfSfanj 8Jg8tlhmJHD2vhUwtSS1Xbwc44IcAfYDqSPCQbFQPBTZzF3OvxTVFEdUlfCZBmfdopqPXK06Dr1a 9Ry8VPUedInqO3CJGtj/IjUInIa/T8V7/L+OQ69SLUasUg3PullVnnBXQsxbAcXsKmMK3mPZE+4u W6fwfBMwqyC1ZTwco4IcCp4BUqMHBB1PAUyh+DCScVSbtVf/XTR+neowbLkaMGCRmtKzVF3R/gx1 Z7MealeDNurpWo3Vweq11eGq1dWRSpXVj9HUPwUfgl+AXyb+5nv8v7cqVdKfPVi9Fr57nNpTv5W6 u1k3dXW709X0npMh4kWq07BlqsbZt0P4D6uC2agDR1nWKXqRMtd5NpDaNrccY4IcAp4FUiMHACGS IZchlB0/a7eqeu7dqiVGsFF9zlPL2g9Wm5t0Vs9AOO+hCX8n8FvwK0DxGeH9BHwA3k/Av/meEepH gN/hd9OP93tA4T5bo4Ha2riTWtl2kBrXe45qM3yFKjwXIypH0Nn7UOcHVcFkhPxowvxLYDSQ2jo3 HCOC7A52A6lR/cOO5WjDzkWnloy6Xk3oPQudP1A9XrdEvYPmomgojj8CiofC+mFMUJAcWT8Bf0j8 /S54sk5TdV2bAar05Om4aFY7HnQWzoHi5DlJ5xoM2h76cKnto0USZM+le+QP5x91wa3gP0BqyGCU blYnDLtGXdJplHr4uA7qTYRQjlafgl8Dio8jIoUpCSZOWAfWhXXihcE6ciQ9UqWa2t6wnVp64ijV 7cwrcWHdL5+rHVyxagykvogGSZBvfvj7gmqTN8lfyB8mgp8DqeHswKSk29BluoMRJ9TPwI+AJIh8 421AgTL8s+5/A/1Ov8yZaEnnag+XT7mWL/VJeCRBklV7DstfqHh4hW4HUmOFBJMChOvWI69ThzEh +TOa5y0gCSAfYV1pJ96uUqg6Y2ZfMHM3QnZOZuPkG6AtkPrIHkmM5LPPv8jH0M3lL642SA0UDexA dGTrESvVq0V1tF87GkRpxHikWrHqOuQKZ4IjnV+0/AFcAKS+skMSo+Gm/W/IX4qfhuBhIDVKdpgi KYWPCmTuIcpZe1QrTGpeLaylJxD5LEojxnfgebvQNwYVI9uGM3O2lU7EBx5V94ISIPVdMCQhGtYf OCJ/KV4GgQDrzYnG5AwT4bdk5CpViQ0eeMaJ48x5RLUYfQNEWTNvw7cR47uVKqvOw5ZBjI+k6l/m nATYJok8ZsmIVU6elcLU/x9ImJ+A8El1SYiG+57DXE76UnxcCqSTzwAakKMhRggmkL+G2fIvMevc 2Kw7BAlzz4YOKkocq9WI1XnpKY0Y3+bISM8451HhHLJgxAgR3tyqj/pV5apqWfshqt642/TFqFeL gomSLAdSX/pDEqJhx8H35S/lHm6T2gGkExZAozHUMH9Yulnn416s0UD9FafHGfOfwG3NT3ZmnCSI KLWnxEQHo8er1fPHUxoxvgXP2OVMC8/I86IYp29TK9oOUH/BsZja4kX3CrzznB6TnNUftmnwVaAn QSMg9W12JCEannz9Q/lLuaUdOAykEy0LG1aH552q1xmXq72N2uvG/Q0wHcd0CMW5tlkPZ5TkaBl4 pMwfT2nE+A5m094JjE/R6JHxAS225W366xwm85nmnHgRM230RL0Wqv/Ai1NhPNiMnfcPdQVSH2dG EqLh+bdQNelLuYP79P4GpBP0wsaZdI8OLdUnbFQr2p+hk9gUIwXIvJzpQP7NfOK/wB0lPe1GSnb2 3Ee1pzwMT8lRtyJEacT4XqVK6kR6RoZWU78ydRbQFzDEOGu3WtGmnxaeW4yE7cUVIJ7jx+CGNgNU zXPvdMpim/sXJnfcLwU9gNTfZZGEaDj0Y3Sx9KXcwJQOt99LJ+bFNOrsvWrIwCXq+VqNtRCZyM4k EiPKf4Dbm5+U8JQ2I+U+hO/V6rXqtWL3lCyLqzH0jF05m7b2jNv1cijFyOVI98WbXh7X2jmCHqpR X40+bb4TwnW7+RYloTC5K1/qdy+SEA1vfYTgJH0pei4G0onIzNipCvHvNRgV/w+nwKuYjZqpYQ1G lBTvbRSlHikDzr7ZERhd2sTsKVmG9oxVixCmv27hGRNiTHhGMzKW12aEZbONyfX4bs1zMFqiDcRy sjMfSP2fQhKi4cOP4bykL0UL7z+WKu+FQuAOHITNdsNXan/D0Y5XsJ9GNRhR8qq/XXtKiDKEp/we wneuPaUR47sRe8Yg7cY68DsU8rOISHpWzxQT85fBRssrgKQDB0mIho//jC6XvhQdvDNOqrQX06AI 0RNOma0+qFRZ+xtuMAjSqAYjSq+ntEgJJfKUufSURozvMc84NIxn3JPRM/rFtDV3OnFGPqvHZD2Z DG59NtwEJD3gqIIQDZ/+8zP5S9FwG5Aq64UNmtgpvazDEB0i2RhhO9+IkqPsWqaEQuQpmRLKhac0 Yny7KkZG7RmNGH3Ctkt4xhXwjH/HsYKOjBKsF7e+8XxvxIhbMHmz4y2DjZR8OkdZXUhCdCN+KTzX A6mSZSndrJqNu03d17ijvrq5qTWqTjeipKe8VecpmRKy85RtYSOYPI8qfBsxvlXN1jNSjBgZtWd0 JjBRiNHA+nFCxLbb3rCtaj3mJlWZixJSXTLDx8ZUBSltSCJ0U3vGfW4hRcEyIFWuLNzLh6vvsVpN UBOnMaNqUIMRZcpT2uYp9ybylOE9pRHju1WqQYxcm96bKqdM2QKse8IzXoMRzFzIuWg71pV98wIi RCHrp3erC3XKDG81ST3MQBKhm8bztqYLKgwLgVQpGa4QYMQa12ee+jmqylneESA1ThiMKP8N7ijp 5XiiwL4InTHnUdUSoqSntA3fRoz0jM5yYFDPSDEiTOs8oyNGW89YHjwm7RMT6RNPmemUqzdnCPXK zhugI8CRBBG6ab3wYUlYNjAPJVUmC+gEihKdwrv0ePsAk9+5FCV91hrbZUbWF6NZmxErrTylESPz jN24HBjSM0Ydpt2wrky58Z6hYcxPMieqlxiFevmDj6/B0QQRuul22W5JXEHpC/4NpIqUQ0KUmCX2 H3CR+nmlSrohcnHFs+O4ypPylBBkYE8JknlK/57SiDG8Z4xHjBwZKcahfS9w6hp8vdvNCsBH2uCI ggjdnHbVo5LAgsCnRXwMpIr4JCFKXIX9Bi5WPyuopNeqczlSskPXlhhPabF1zXjKajXKFaURIz2j MzJa5BmZ2pm5G54xWNI7KEaMHBQGc2SkGCdZi5ErOFNBSi+SCN2cueobbnHZQH8gVSYgCVHOe0z1 H7hEh+84PKVeZgzhKSnK1wprZAzffI/LgdozDgvnGZe7xJjtArDFLcYz+y1AXfeHGRn/CBg5vXqR ROjmrBsPeL8QjAeAVBlLEqLE6HN6/4U6ZOTaU7KDb2txir0oUde2w1eo1+Ep05Pn/DsSz4gwvbzd oNjC9LC+oT0jnxrMXV1lNSOJ0M20dc+W/ZI//M2o9bNs7nUaV/r/MlCUmMnRU2KiQ0/JhsrFiGBE mVr7tgzfzFPyHh2Xp0yJsUh1OcPWMzpiXBFTmGYyPALP+DpoCiTNoARBhG4u2PRt+YvZ4Y37UmVS JBq0aNwaR5ClmwOKEg1CTzlgsX7qQzyesicEYJk8RycyfB+uVqyFSLvxo8pVVTertWl8LrGFbFnA jRJBMWJk+w4JL0Y+da4ISJpxkETo5pKtL8lfzM57QKqQAztz+jZVeM6d6pXi+mp169OcpSeOlr47 OiHKuY+pAZjoHBWeci495XXqPQiRPszutgMcx3hGlxhzESGMGMnQ0y5E/UN5Rj4vqBBIekkhidDN VTsOyV/MDB97J1XIwTQoRpl7mnZRX6IKDImXdBqhZ4mOKP2eMD7HBoJPGzQgZk9pu58SF17XwUvV qdyJzY0J4ucyYNoOF3McntGbZ4S/tRcjn4HOx2VLevEiidDN6csfk78oMxZIFUrBHcez9qpLO5yp G5Q7driFjDtItChx5QcP3/F7yltsPSXPi0Jm6Pd9jkCL0ckzXtN2oNUWMr+YkVF7xj7nhw3TfN65 k2P0gyRCw3NHUCXpSzI1wG+AVKkEOCGEqCF9ztM+io/9YIOyAfg3G3lxx+FaXLaesj88JZcZc+0p 9YqO3rq2zRktA42UAWE7JLaQXR2TZ2SkGcLZNPc82ouRD6kK9ts6khANfa96RP6SDJ9dLVXKgY2K ENVkzM36HuL01RYjyn+Ci08YZh++4SkHDlgUm6fUW9c4UgYO3z7RIyPCNNpjeUwrMI5nhBjheUOI cQuQdJIdSYgk4B2HfIC8VKkEOCGKC6Pe7vqtMm5mNaKMwlPGlafkqJ7MU0Y9UhoxujxjtntgwmDE 6OQZMZsO5xn5qw+STspHEuOXX6qCXv/j+7k+lQETnVLFEtDj7VaLTxiqR0De0SY1CjGipKe82NpT oiG1p1wUn6dsYbmfMhM8BsU446jzjJzUSjrxhyTIRw5hmiF9WOYSIFXMgUKCOLoN/h990swZlteo RpShPeXc/fCUECWOk2tPyZ3na/TWNYbvkKLkdxN3VRrPGOXGZDdGjI5nZJ4xMTL6bmsPm4GkEf9I guxy6S75w2Xhb//9A0iVAzgpNizE9EStJnrU89uoRpS87+XijiE85TwnT8lQlGtPybquNbNvW0/J 89OecZfHM+ZSjMTJM1aAZ0xHEqT4QRn+vp5UuRTwIgsRerm5QGqUbBhR8rsXdxppH75n71GD+y/Q ouRImYvONaLkqH6r7dq3ESM84zXwjHGEabbJ8L4I0/SM9rt27D1jOiEEyR2+XwCpgk7jztih2g1f AVFV8hWqJYwoU57SMnzP2qv3U35UyemIXIqSnvJWesogy4z8jPaMO9SymDwjd3oPC+8ZmV2R9GFH CEHyBh2pgg5cn0bo2tqwvW7cMAIwomT4SnlKm5TQfoTvGD1lc3pK/ihSOaLkeZg8Y0xbyOgZz0zO pu9BPazEGN4zujhj5eOolZ0gOwGpgglwchiRhvU5Tz/kiakKqXGCYESp85QUZYg85aCY8pSOpyzn dgjWX3vG3Tq1E9vIWFF5RoFKEzcUXLHtlYL/fP4FamYnyH1AqiTAyUEoVSdsVN+s2UivyER1pRtR 0lMuOTGEp8RIFJen5AV5S8veOlqUEaURIzzjsnanJ0fGXIoxIs8YWZhuOGdLwVOv/zylPbcQk28K X3RRzugI4ElmdD9Xd0a2nKMNRpSOp6QoLT3lbHjK/guTecpcjpT0lDdzpITwkp7S5RmvToyMubhV lRgxEkYtxzNah+nIxHjqFfsKPvr9p17tuV8k3xS+7CL7LnA0eNG5d6rvFtbUy4O5amCKkuvJ4T1l PGvfSU+pRclUGOoLW3NVIrWT6zwj7UnKM+Y2TEua8ov8plBIAv6U7edAqizYqK/4y04YqpcHpQaK CjY0H7/Hjl6iRWnpKefsV6f3v0iHslwvM9JTrmFKiNvOcDHE4RnpF8lwijGcZ+QvxkqaKIOkKb/I bwqFJFgJpMo6cGY95QG1t26JbvxcXPFueHyOlBT/kjB5SnrKfvF4SloNhuhLOo7QzymKwzOOYGpH e0aGaakdyiVQmJY05Rf5TaEQUA2U/xsx8EUnjFytXiiuF2hlxha3KEPlKeEp++n7vp2OzNVIyf2f PD6FT3+dSzGSivCMkqb8Ir8pFAImAanCaeCk0QDNxtysDhXVCZ2D9IMRpddTWogSYZRb13LtKfkw gvTHTkcF24Ihmp5R35AVLs9oldqRNOUX+U2hEHAASJUWwMnP3K2a8TdeIErOMuMU5ZIwu4TgKQfn 2FPmCrYBR0UKckR4z8jJq6SDcpE05Rf5zbKFtALBHoVCIczcpZpDlC/VqB/Lo4+NKBm+F584KpSn PKPfhXo7VvpG4nyFdaQQWeeRDNN8+oUeGaXzLJdQqR1JU36R3yxbyJVAqng5oIPhzUrG3KReLKqr hRKnKJ2Jjq2n3Kfv0eGKDkWZzyMlz5kjI+s51HhG+6T3/UDSgG8kTflFfrNsIW8CqfI+QKPgam0G UX6veu3YPeWiMJ5yHpcZc/vUtbAYMdIzenZ6+z5XD75TO9mQNOUX+U1vAfzxG6nyAUDjwFPyF/q/ B08Z9DF1NrhFuTjpKW3ylI/CUy7UoTDfRMlzNHnGEXo5EJ7RfmSMRIxE0pRf5De9Bfh/4m02KATj KYvrR/bo42wYUUbhKQfDU3Kiky+eknXgyMgLZXgFe8Z0JE35RX7TW0BETy8j6GD4m+ZjblQHK8RT hslT7lMDMFLmg6c0YmRqKplntB8ZI91CRiRN+UV+M3XwDuBLIJ2IQ+BH+Dqi5ETncPVasXpKLjNe FEaUia1rFZkSMmJMecZEasf3uXiwTu1kQ9KUX+Q3Uwe/EEgnoqnEjuIGVO3NsmxALQO+B0/ZfNR1 Ok8Z10jJtW+9yZezb72f0kKUmDSc0X9BhXhKnoPxjCO5HMg841HuGdOR30wVth1IJ+OA0XHiydNV nbG3Zt6AmgkKgZ5yzA3qYMyekkuaR5unZBkcGfUEJukZKUapnuWSN54xnbJvpArik6p+BaQTQkfe r6qPX6e3TT3eoLWqzJ+D4CbUoCNlIny/FONImZzohMxTDkjkKSmUXI6URozaM546L6xnjGyntyFd Q2Eo+0aqoJOAdEIOGN36DrxYNxIPc2+TzqpgKjecbg8+Uurk+Y3q1YrwlB1DesocLzMaMdIzOju9 jy3PmE7ZN1IFZf6F1sTTxhZ0HqPzfNy1wt3hm5p2dTafchNqYE+5K5mnjNNT8gJYzNshtKe0yVPm zlOyjknPGD7PmBMxknQNhcH7wltQ5p3hkxCeMaLc2+RE57HEgKLkJopNGCkrc7QJ6im1KHfrH7N8 qbheBXjK0QlR2nnKM/rN16KMKnwbMfKYI02YZll2Ygy9HJgNt4bC4n2RKoSPUMucfyzdqmqOW6Ne rlZDeyg2oNlWxY25FGpl/iycpadknpKeMs4VHZbleMq9dqLEJGNgRHlK1onC5og7rE9ozxjZbDoT bg2FxfsiVQhvVfgnkE4QIXm7Ovn0y/RuZz5s1DSkESUfU8en4zrh295TxpmnNLdDXKRFaTlSwlPy dogw4Zt14chIz5hcDrQfGR8E7n7NCW4NhcX7IlXIYCCdIKBg9qnpPSbpcE0BuhvUiJKecmPTbiE9 5XWxekqOlF5PaSHK2Y+oIf0cTxl0ky/rwJFRh2md2qFntN5cm/OR0eDWUFi8L1KFZH6iWWJCs7p1 Py06qWE9nhIj5dHoKRfRU9rOvvG9wac5+ykpMD/15meSE5g894zpuDUUFu+LVCF8eJB0ougg/mTw ferBRu11WJEal7g95T3wlJVCesqXi2rH7ikvYvIc9kH/QHlgT/lI0lOWN9FhmfyMTu0k84z5PzIa 3BoKi/dFqpAXgHSyCMEPqhqY0LyAUMp7T6QGNngmOk076zsS7TzlPlUymp4y3v2UXk9pkRKaB085 IHue0iNGszZtP4GJxTOm49ZQWLwvnAL4RNzMvzMDQbUbtlwLzc8ze9zhe+Px4T0l177jupuREx3a kkVhlhlxMZ2ZuB0i3VMaMTJMjzqKPGM6bg2FxfvCKaAZ+AuQTlo/CGBQv4V6dEyf0GTCiFInz02e 0uZX++EpW8JTHozRU1KUXk8J6xGBpyQUIl+PPHWuE6btPWPkW8iC4NZQWLwvnAJ6AemkHSDIaT0n 68akyKSOlDDhW6eEuMyoJzqWnhLh+xWE77juZqQoWZbjKS1FidFvEDwlwzfbjv86npFiNDfxW4kx ZyswfnFrKCzeF04Bw4F04g4zd6rLOwzRjcmb3qVOzIRnoqPzlA8G95RalHv1znP+aj9H3ThEWdZT WoTvuY/pW2yZLuM2OH2rargwXSGeMR23hsLifeEUMA1IJ++AzuDPYDCMSZ1XHkaUHHHuPr674ylt RsoK8JQUpTNSMnxbihLfG3fKTDWp11RtQY7mkdHg1lBYvC+cAi4FUgOAjXpEu79xJ2tBEren3Gjy lH4ffZwEnYjObTnq+ljzlAzfvMf8os6WeUr+y5wsL0L3e8GIfAtZGNwaCov3hVPAdUBqBFzN92r2 1G+ZNQfpB9FT2sy+6SmZp4zZU/Ji0uGbecpAnhJwcSHwrR9J8mZkNLg1FBbvC6eAO4HUEFo0Vc65 Uz1Zu4neQCB1WBCMKPmY5k3Hc+saPaWNKI2nrBmbp6Qo6SkXak8ZdKS05iHgEUM+4NZQWLwvnAIy bzubslXVGrdWPVejvk5hSJ0VFLen3KDzlBClpadsPvJa7SnjemwLRems6Nh4ysDk3chocGsoLN4X TgF7gdQgeqWl0Zib1HcLayW3nUWBEaX2lE2Mp7TIU2KkajmanrJuBXjKMbkcKfPKM6bj1lBYvC+c Ap4CUqNokTTjzLZqkf7dGamTbCnrKbfYhe85+1SL0TeqQzGnhDjCLzBr39GKMi9SO9lwaygs3hdO Ac8AqWH07LD5yNXq9SqFemSQOigMbk+5kZ6Sv+9iI8pZe1ULXDivxyhK4ykX0FNO3xEmnePmYeDp /HzEraGweF84BTwNpMbRgmw1YqV6s3JVPSpInRMWI0p6s7uaMU+5FTwQbMThZxOekvspf4dj2WyW DQJFyc3Kn4Gv8fe+6YP1UqBQP3+E+1XVGHFrKCzeF04BFSpIQlEyT8mdPdsatFF1z1mvCrh9TapT JrQod6sG49aop+o2i2wSlgkKksuBXIWZ1rNUt1VIQfLX+KsAT+fnI24NhcX7wikga8guwajzWo5C toGC5L/0kwdqNVK1x6+DLwsqSIR5jJL0c3sh6ijSVJmgGLk+TTEO7zPXmdxwEUGqVzCeB1WBRwD5 RLXJmzwaCov3hVPIE0BqHJ2SOZ63qlYtjnxSY6AYuUbOtd7tjdqpQj6AQK/iBA3ZO1Xtc+5Uz9Ru okN2rnykESO3lo02W8gmRuIfDd8CvOnOI4R8od/Vj3o0FBbvC6eQ3UBqGO3lmPZ5KeK0jxsjxocb tlVFDHl680VwMTYct1YdgBg5qTEjbtQYMdIOjOZObz4sNJrJTDrPAv4KhkcM+cA1u171aCgs3hdO IdzoKTWKDn81zr5dPVujge4IqZPCQDHywQPbMDJWtxbjLvjGteqpOsdrD5prMdIKjOo9Ry9h5kiM BobvYuARREXznXd+7dFQWLwvnELWAalB9MSiEjr9G+hshiipo2wwYZppk12N2jpr5jZinLVbFSNM f7N2Uy1Gc+z08sLi9owjuJ9RP0YZYgxSXzsoyryZ6BRPvbfgX5997tFQWLwvnIJWAakxHKFAlLvq t9K+TOqsoBjBMEzvQJiuQs/IPF6Q3KMeGekZ16unE2Hafewo8XhGHaaDekZ8jqO//WiaN55y2LVP ePQTBd4XTkGLgdQQADPHGTv0g6V4r7TUYUFJecZ2Cc/IRHiAjuJnZzie8SmXGHOBESMZY0bGIMJi Xfl53uzG3Cr/thtV/xfw6XQegcTNTfvf8OgnCrwvnIImA6kRHBAWb2zVR6/fSp0WBBOmOZvWnlE/ OS2gGOEZ68PXGs8olRMF7pHRyjOyrhz90X4LO49RX+8wRF/cgbeupWD4LgIekcTJqx987NFPFHhf OAUNAVIDOCA0XtZxmL6tk4KSOq88jGfkBGY3wrR+eJXVBIae8S71zTpNk7PpXIZpbthwbsgK6BmN GOc+pqb0nKzr+h8w/8Qxztr3ZOu1b4Zv3iXqEUoc1Ju1ueDzL7706CcKvC+cwroB6eQdcFWX9pqi Ux1c4pM6MBtGjDrPiDDteEaKMbhnrDN+vXqmVuNYxOjkGROeMXCYxjkivE/pMUmLmjlcLjPyglxo dYuthwrxlONuPuDRTlR4XziFHQc+AdLJa0H2HbhEr9TYCNKIcVvoPOMa9SRm00aMUllhcXvGs05F mLbxjLzgMJLPgBhpc3j7MI9L2Ib04gs7n+Ws7tiHb66uxeop1x844tFOVHhfpAp8G0gnricdLUes 0sLy86AANyZM7/B4xqAj4y5V7+w7YvWMo+kZbcUIrzmjx0Q9MnIxgcd1l0FR8v4k+kqr2yFScKSM zVP+8BefeLQTFd4XqQIzr2djdljMXePF9X2v1pgRjGLc07CN01FWE5jdqggCPuASYy7DdNIzBs0z GjHOe0yVwjNKYnSXRVHyfC6IxlPmPHw3Pe+Bgi+/9AopKrwvUoVmvq+GDV26Rd3X2Hl6bnoDp0PB cGRkgzPPWE0nve3yjPSMzDNyM6w5dnp5YaFA6I+5AnOWyTNajozGM5owLZVHjChpZRZYPXXNA5cZ czrRmXrHsx7dRIn3RarQBUA6WbBRN/aytoN8hUy3ZyzmnXY2npF5xrPXqicxMuY6z0gxcnQcE9Iz Tu/p9YxSeW6MKBm+F3TJb095/7fe8egmSrwvUoWeBqQTdUBY4Uybt8L+CEgNTIxn3InZdGEIz1h3 /B3qybrN9AWQ6wkM01mje8+GGBN5Rr+CMGLExTotMTJmCtOZ8IiSE53wnrI6cPdrJPzs4794dBMl 3hepQhuBvwLpRPVu6M5DrtCzbGmjrgnTyTwjO8rSMxZDwHGtTVNEo9wrMEHFSM9oKUaDESWjynyG by3K/PKUyyPe4ePG+8Jb8MtAOkntIQvHr1PfLqpdZie2ESMbNOUZbUZGesZ1WowmTOdSjI5npBgt 84yMGj49Y3m4RXmhvpsxVJ4yJ57yyu2HPNqJCu8Lb6GbgHSC6ACIbMoWddfx3cssIcqeMaAY4Rkb xOQZKUY+Eu8sT2pHqJcE68qREYIJ6hnLw4gyGb4pSvvZd0485dKHXvboJwq8L7wFXgCkk1MFE8Gs vWpO93N1WHY3pN5CBjFqz2g1m96NkRGesY7jGd3HjhIjRvpg7RnNI/H8drgRI0Q8NZHa4T01UYjR 4BblhZzocP2c9xbZifI5ELkoL97ykkdDYfG+8BZ2IpBOzGHGDtVj8NLkMhgbUOcZG4TJM+5yPGMM eUZaDaatRof0jJPLyTOGxYiSUecC84Ar+5GSokzv59C4NRQW7wtvQTTDPwHSiWnfVBXi+d/i+nqU oYC2c2Rkx1qG6brnrFMH6uR+C5nJM4619YyTYVnoGRNijCpMZ8KIkm0cgafk1rVIJzpuDYXF+6Js YfwZW+mkELbpD7epVW0G6MNsb5TwjFapHXjGcWvVEzEsB1KM9IxjTWpHb64V6iWhxeh4Rj5FmJ4x VyNjOkaUTvgemxgprcM3b3WOLHy7NRQW74uyhc0E0gk5IMSO6z1TPQ2/V8jX2jMGaCAtRnrGddoz MixJnREF7FDjGUdpz2i5nxHhnWLMhWcsDyNKbsi40OQpw3nKSPKUbg2FxfOi3aLt6YXxAfj/BtIJ oUPv1Td9VTrnTuU8HCqgGGftUkX4N4616TKe0XI/46SepRUiRoMRpeMpGb5DJc8j8ZRuDYXF84Iz JqHAF4F0MmgEhGZ2VFA/w8/SM2JkfCqxuVZq/CgwYnQ8o+1yYLyesTyMKB1PmUgJ2XtKhu9QeUq3 hsLiefHC2whqZQvM/LvZNiTE2AAja5ye8Sz3cmDQpHfCM+ZyNh0UI0r62PnhPWWoPKVbQ2HxvPjs 8y8K6s68P73AtuALIJ1IMNhY8Ix8NIpZm2bj5nIFhndHOnlGW8/4qJpawWE6E0aUeqKjPWWoPCVX dKxE6dZQWMq8MW3ds1KhLwHpJPyjxeh4xjjyjBQjPeOY3iHyjNozTtbHyZeRMR0jSuaAI/CUFKXU /1lJ11AYyryx86X3pUIXAukE/MHGSXhGsxxIIeZyAkPPOE6HaZu1aXhGhMDJiZGxoj1jebBuXKBg u87nSIkoFEKUgT1luobCIL5J0grlfTafAukEspMQo+MZc78cGJVn5Nr00SBGgxElPWUEecpAnlLS jy3im0QoeCeQKp8ZNgau1lrnrFdP1C1J5hlzHabDesYpvfLTM5aHESXzlBdE4ymtHnAl6ckv4ptE KGgYkCouo8XItWknz2hSO7kM0xSjZ9eO344wYoRnnAgx5rNnLA/W2eQpzz8KPaX4JpEKAu8CqeJe ePIuz2jugckFRoyOZ7TMMxrPmBDj0RKmM8G6c6Rku2tPGS5P+U0Qm6cU3yTdLtstFbYESJVOwZOe 9pBqCM/4DVdqJxe4xTj2lFn2YVp7xvzKM4aF51BReUpJT34R33STVlg9kPm3tMmUraru2Xeop2s2 zHmYTnpGLUbLMD1nvyqN0TPy+CyHdY+jLIqSPyBwQWeIMpyn5C4hX4+XlnTkF/FNCVeBa4BUYYep D6g6GB0PVy3K2aOUecykZwyzHDh3PzzjlNg8I4/PzR0vFtZSzxXX0+XGUSbDN/OU5+nwjZHS3lNS lG4tRELnS3YW/OZPf3d0li68TLgOUAL+BaQKA5zo7L1qTO9ZeraX7a5EG9jAHF2Y2nHyjDZiZJje o0pjzDPy+AyfP6hWrFqOuk5bmpeL6uo2iqNsM1LO587zcHnKwJ7SD50u3lnw6084FRPEJ5F2AP6G ilRZB3Y4TPSuei31slZUDc7jcGTk402SnpG7dizEaJYD4xoZ9W/lVKuhOg1dpj0rMxD8FdsXi+vr esRRB5OnnN9lnB40QogyJ/fodFi8HbUTxCeR9mVuS/scSJUFOEk0+kmDLtUNYG5xCAMblCMjO2+M 2zMGFSPC9OREmI7LM7KsI1UK1QnDVzgjuq4zwAXVbMzNGCnj+2llk6c8nxMdLhyEm+hE/3hpSXwS wpczP26F6AcD7FRrmvXU/iVMY/O7xjOO1amdxHKg34bUYjSesVSPVnGJUUeIqtUTYkS9PXWjKPeq ktE3qMPVa+tJYBx1oiidPKXxlKFuh5C0YY8kPgnhy03B34BUUYATnLZNNRx7izqCDqGgbGbbRoz0 jGfbesYKyDPy+IwOb8Ezdhp6tRMiM9UP4btk1PXqEDxllBYnE0aUevatU0KwEPYj5QEQnaeUxCch fnnChhVAqmQCnCAENKnnJN3Q/Lk4qYEyYcTo8Yw2s2l6xkRqp2I8I0YhqX4G1hOfaYGR8iBm33F5 Sk+eMl88pSQ+CfHLzvMIfwukSjowHEzfrh5s2DZQSOLn6BnZYNozmpHRb4NpMcIzztuvJp0Ur2fU gqpSzeUZhfqVAfXFZ0vG3KReQfiO01NypDwvGk8ZfqSUxJcN4SDZH5LP2xwQklqMXK0+qFRZh97y Gpr/z5GRo4y1Z2SYTnhGijGukTHlGZej/HTPWB6ot/GUmOjE5SlTa9954Ckl0WVDPMiEDd8BUgVT 4EQZunni2XKTRoxJz2gzm9aecXdyNh2nZzwCz3ji0Ksye8byYP2ZEhp1nXoF4TsuT5lc0YnGU9rP viXRZUM8yIQNHcFnQKogwIkxfE7fpu48vqu+8qUJjhEjH4k39uSZ9p5xdsozxhWmHc9YrDoO8+EZ ywXngWM0H30jPGXd2DylyVNe0LUC85SS6LIhHsRhJZAq58ATw6y7GH9/t6iOHrncjcy/KcaUZ0yI 0W+DaDEyz/iYmpQYGXm8ODqSgjmS9IxBw3QmcD4JT3koZk/JsvQyY0V4Skl02RAPkuI9IFXOgSeG ENzjjMv1yGVGL0LxcJ3XsxwYRIwM0xDDBIiRo1XsnnGYjWcsD7bXXtVq5LV6yTFOUdJaaVEi2oQc KSWdZEYSXTbEg6ToDaSKuXAeCT2l+0TtWegnKUx6xvHu2XSQMJ3IM/KpvnF6Rj0y0jOeCc/IjbBS /UKD84OnbD18pXq9eq1Yw7feec7wHc5TPgn8j5SS6LIhHsTLMiBVLAFOiqF1xg61sk0/HlGPaONO gWe0EiOOBTHEvYXM8YxF/vKMocF54hzbjlytw3fcnvL8rmfrQSRk+PZ3O4QkumyIBynLQSBVzIEn xR+fhDB3HddBzek2XodyK884j7cdxO8ZnTwjwnRQz6jrjY61CYO4YFtj9v1GzOGbZc3TyfNQouTd jOU/dU0SXTbEg5TleJB9I69+DAtOjuF2ytbgYkx4RooxTs/IEYOesdOwa4J7Rp7zlC3OhcTz5XkH eVIc4Ug5YqX6QWENbXniEiV3/if3U9qLklvXJL2kkESXDfEgMuOAVCkvFBY3YgT2jKk8Y1xi1COj 9oxXBg/TFB6jwrSH1e3NT1JbmnRyBDn1weCihKdsk/CU6dmKXGBEyQnc+V0Qvnnu9hOd7J5SEl02 xINk5logVcoOLUaMLph58lZVdkbceUYrz6hHRohxxk61utVpOg/7T7C+WXdnxNRPjgsiSrQD2qCi POUFej9lqPDNFR3ZU0qiy4Z4kOw8BaRKBYMnnvCME3pNjVWMusMrV3XyjDZhmiMjJnHXtuqrn8HO 34jkRpPPwJ0UJUfJ6Q8HFCWoQE85VyfPQ3vKsnqRRJcN8SDZYcb+h0CqlE9wwgnPyDwj85Vx5hnf hmc8kSOjlRgptm3q2tb99Kj4Po+XgCkv7hW9o6SXDuVWooSnbIfwzTxlXLdDJD2lXmYM5Sm5zOjV iyS6bJQ5gD9agey7gjKhw7TxjM7IGLdn7BzGM07frla17q/DtBGjKYN/vwc4Obm9OUWJ0G3rKTHR iTtP6fGU9qLkQ1ObA0crkuiykfxicJg0z/w0XgkjRvglJr3Z2HF6xrequvOMARqbgtKecYdaBc/I EJcuRoMRJVdG1h1PT2kz0UHdtKe8Vn0vZlE6ecrQ4ftU4OhEEl02kl+04ywgVUhm0j2qMkw/f0s6 TjHqDoVn7MjlwMB5xsTIiAmM2zNKYjTw/xi+HU/ZA9/HSMkQHnSkRF3bjLpWfT9GT8ldQhz9L+9w hqpu0llS3TIzDaQ0IokuG54v25H9QfpucIJVSu/Xm3tRsu60XDYyj80rPukZbcWIMJ3uGaXy3BhR cqRkWii0pywsznmeknXm5Ix983jtxqqIIzVFKdVLhk9C8epDEl02yhzAjguBVME0cIKlm1Xh5HvV qrYDdQPnapTkMXVOLyLPmC1MZ4KfTXpKTnQ4UurwHTAMztytk+ev5TBPyWMyZHMidWuL3qqYuWRu 7PVvba4AZbUhiS4b4kHs8PcQVFcInNarVE9o2MhBOro82LiOZ+QKDD1jwI0SrCM948ydSc9YXpjO hBElZ99OnhKecpqNp9yn85T0lHp1CUjl2cA6sr14i8n8ruO1Vw5oMWQxEkl02RAPYs98IFXYC0cI hgKE0JOHXK5eqV4nufM8bEPz+/SMb8MzdrLZQpa8YHao1T49Y3nwu8ZTrteeEoK08pSPqDaY6LxZ rSgST8nvmwnYDzDhGzRwiTOZ0bc8+K7b5UDSgoMkumyIBwnHHCBVPA2GAmfrWv3xd6i7S3rqhuGG CtvOZwNz9PghRsbOvFWVu43EsjOgxQixIEyvhmekGIOG6UwYUSY9Jf2kjShhPdoPX67XvsPkKfk9 RidOYLY07aKajFujZ/aBln0nbLgESBpIIYkuG+JBwsN1778D6SS8sEPYMRDCzF5T1DsY2ZgPo7kO IgQ2sOMZi8KtTc/Yrla2cTxj2JExHSNKCkl7Sus8pfGUtQN7StaBPznNNubFNr/bOY6NwEUYwNt+ Cbyz6UxIosuGeJBoGAD8Jc91CL8fI9o+1R4+adtxJ+gG8/uIO36GHkjPpq09IzpFe8a+VhMYv/CY DJMcfZN5SgozqCgTnvLVwpq+PSU/w0kkJ1n767dSXc0DD4LdlfhHMAJIfV4WSXTZEA8SHa2Bz2XG RINwNzNGzNk9S9V7VarpjvsAZBIHG1mndphnHM4tZPvTjlsOyZERnrH1aTq1E/XImA6P7fGUFKSl p6Qo6f+yeUqWxwuMduH9SpXVgu7n4pxRJtuatsl/iP4IdAVSX8tIopP46PefygeInrrgESCdYFnY KdwKhZDbcsxNah1muXyiLkWXHsbZARxJk56Rm4KlY2ZCi5GecZta3aafngnnamRMx4iSa8jJPKWl p2w3fIX2lGwLtyhZBtuMkzyyCeW0g4B1BOGupGBlcfNEEyD1cWYk8Um880tUXzpA7gi4dQ1X7bRt euQaNOgSta9Re+2XuBGDjX0EOJ4xRJ7RLAcmPGNcYjSwLIbvsnnKgKJMeEo+4Epvq0scm4+sYRs9 3qCNGj5gkSN4XHzO93yPimQ9kPq0fCTxSXz/Z6iqdIDcMgn8HkgnLYBGm4RZH0NL6RY16dS56lt1 jtejJUPr27wHhp6RqQrx+xnQIyPFuFOtRJiWNkrEhRElrckdOk+Jetl4Svhv7Smr11L/wrF4gR2s 2UjNOHma48/pFbmPIJgQ/wpmAakv/SGJT+Kl9xAIpQPkHt4O8TyQGiADaEQabwivyqT71HndzlUH 6jVX3U9fGsIz7tSpnSDLgbmCZTN8/xvcUdLTPnzDU3Y88yr1dN0StaTLWaqI7+lJC8NzICGSw6AT kPrQP5L4JJ558yP5APGxGkgNkRk2qk5RIOzwiRb8W/pcJowYtWfsH6tnLA8jSnrKtc1PduxKYFHy woX4OBKyjTjaBhciWQusfmSpDJL4JJ547UP5APFyOngVSI2SBcwM9S4UzhCl/xdgx7KDpu9QKyrI M5YH62I85Vrup7TylBZtk+It4D+l4wdJfBI7DqI7pANUDLz3+z9AaqTwGDHO3KXXpo1nzJQmqUjM SEkrkfKUFhOd4NwMohkV3Ujik9j8rXflA1Qc3QFvFpIaKxww9XUQzu5q1gNn7uQ181GMBtaNuVDW 9aHjOqgG49c7Hlo6t/B8F/QFUp+ERxKfxMZncC1KB6h4ZoOfAqnxgjMRoQuz1v4DFuvkOddvGRK5 fMdHtHA0Ypjkcpokjjhg2awD62JuJaClYF1/WLmKGtb3fMcT8lykc7TjN2AxkPogOiTxSdy0/w35 APkBk+mrwJ+A1JiBqYqQV3jOenXS4KVqQZex6s6SXuo7RXX1aGme0kb4N8O5JJwo4QjIZTwmrM0y 6U/BS0W11d0YyRd1HqP6nH6pKjr7DtTdamKSCT5H/lbQGEhtHy2S+CRW7TksHyC/aAGYlM3yrEqf mA2n3ETAXUCYMNQ9+3bVdciV+v6e61ufprYhPH6ruL4erZhQZpI5HT7rkg/SonApKI5iHGkJ/+Z7 /D9+hp+VjkEo+ueL66rtjdqrG1r11b/N2H3I11X9cbc5mQDubue+RNY52A6cbGwGJwCprXODJD6J K7cfkg+Qn3QAG0GWXxwLCFMjiRQQc5I6X4fXtcatVScMu0YNQIiffNJU9bUThqlbWvZWWxp3VPvr lqinax4HIdVTrxTWUIerVlevV6mmvl+lKqim3gB8j//3AkbfZ/DZx+o2U1vx3Vta9FZLTxiqH4gw sP8i/UsOdcZCfExdcZUJEy5dF86qdQJbqLMdX4AHQGcgtW1ukcQncdF9L8oHyG9OBLeBPwCp8cNh ns/DUVQLBP/qLWIQLt/H5KgKQn+tcWtUk9E3qOYjV6vWI1aqtsOXgxWqNeB7TfF/tfEZflZvROZ3 eQweyxx7Bv7l+8FvovLLp+Au0ANIbRkPkvgkzt/4bfkARwf0P18D3wdSZ0QEJhGcSGgQNgkFxjBq RMYRzQ3TNPw/foafnQjBme/qSUmkExMJ7q66EqTuja5IJPFJTFv3rHyAows+5Ggk2AOy/OjTMQ/v j38cnAMi/83CUEjikxh38wH5AEcvbQBvNHsZ0DdJHXeswfXmSwE9ttQmFY8kPokR1z0pH+DYoCfg zUffBsfSyPkPwAuOIbkPkM49v5DEJzFg2X75AMce9FLnA6Y8sj/EPz/5CdgKLgLcgS+dY/4iiU/i pMv3ygc4tuFP53UBFOjD4BDI/mTgeOGNcQzDOwDtB5dTawLpXI4OJPFJdLl0l3yA/z5agjMA7yln muQF8D74BEiiiQLeKPUB4C+mbQIU31DQFkh1PHqRxCfR8sKH5AN8haEEnAL4QK25gGkm3obB3xVn opkze85s+Zxtbgoh/Jvv8f/4mbvBdWApmAfGAj4ZLD9SMjlnQ8H/A2+drWDCE5qqAAAAAElFTkSu QmCC "
                                          id="image8054-9-1"
                                          x="147.85022"
                                          y="97.107956"
                                          style={{ display: "inline" }}
                                        ></image>
                                        <use
                                          transform="matrix(-1,0,0,1,275.96909,-7.6922752)"
                                          height="100%"
                                          width="100%"
                                          id="use3265-3-5-6-4-0-7-5-7-8-9-2-3-7"
                                          xlinkHref="#g11803-5-6-3-54-6-6"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <use
                                          transform="matrix(-1,0,0,1,291.54916,-30.973567)"
                                          id="use3267-4-3-6-1-7-1-1-2-0-8-3"
                                          height="100%"
                                          width="100%"
                                          xlinkHref="#g11467-6-6-4-9-3-5-9"
                                          y="0"
                                          x="0"
                                          style={{ display: "inline" }}
                                        ></use>
                                        <path
                                          id="path1947-6-7"
                                          d="M 106.82964,78.986993 H 200.26226 V 125.60047 H 106.82964 Z"
                                          style={{
                                            display: "inline",
                                            fill: "none",
                                            stroke: "white",
                                            strokeWidth: "0.33361733",
                                            strokeLinecap: "butt",
                                            strokeLinejoin: "milter",
                                            strokeMiterlimit: "4",
                                            strokeDasharray: "none",
                                            strokeOpacity: "0.99553576",
                                          }}
                                        ></path>
                                        <path
                                          id="path5596-1-5-5"
                                          d="M 197.49126,98.148982 H 195.04275 A 4.1462187,4.1462187 0 0 0 190.98687,102.29422 V 102.29422 A 4.1462187,4.1462187 0 0 0 195.04268,106.43944 H 197.44078 V 106.43944 H 197.49102"
                                          style={{
                                            display: "inline",
                                            opacity: "1",
                                            fill: "none",
                                            fillOpacity: "1",
                                            stroke: "white",
                                            strokeWidth: "0.24058989",
                                            strokeLinecap: "butt",
                                            strokeLinejoin: "milter",
                                            strokeMiterlimit: "4",
                                            strokeDasharray: "none",
                                            strokeDashoffset: "0",
                                            strokeOpacity: "1",
                                            paintOrder: "markers fill stroke",
                                          }}
                                        ></path>
                                        <path
                                          id="path5623-7-0"
                                          d="M 197.4344,99.835751 V 104.75153"
                                          style={{
                                            display: "inline",
                                            fill: "none",
                                            stroke: "white",
                                            strokeWidth: "0.23483963",
                                            strokeLinecap: "butt",
                                            strokeLinejoin: "milter",
                                            strokeMiterlimit: "4",
                                            strokeDasharray: "none",
                                            strokeOpacity: "1",
                                          }}
                                        ></path>
                                        <path
                                          id="path5625-6-3"
                                          d="M 197.38383,102.32305 H 196.91517"
                                          style={{
                                            display: "inline",
                                            fill: "none",
                                            stroke: "white",
                                            strokeWidth: "0.18910606",
                                            strokeLinecap: "butt",
                                            strokeLinejoin: "milter",
                                            strokeMiterlimit: "4",
                                            strokeDasharray: "none",
                                            strokeOpacity: "1",
                                          }}
                                        ></path>
                                        <circle
                                          r="0.65017539"
                                          cy="102.32698"
                                          cx="196.20464"
                                          id="path5627-5-5"
                                          style={{
                                            display: "inline",
                                            opacity: "1",
                                            fill: "none",
                                            fillOpacity: "0.63839285",
                                            stroke: "white",
                                            strokeWidth: "0.13065509",
                                            strokeLinecap: "butt",
                                            strokeLinejoin: "round",
                                            strokeMiterlimit: "4",
                                            strokeDasharray: "none",
                                            strokeDashoffset: "8.45947647",
                                            strokeOpacity: "1",
                                            paintOrder: "markers fill stroke",
                                          }}
                                        ></circle>
                                        <g
                                          transform="matrix(1.1460973,0,0,1.1460973,-33.528171,-17.85433)"
                                          id="g15871-2-2"
                                        >
                                          <path
                                            style={{
                                              display: "inline",
                                              fill: "none",
                                              stroke: "white",
                                              strokeWidth: "0.20490375",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "miter",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeOpacity: "1",
                                            }}
                                            d="M 125.00317,102.68769 V 106.97684"
                                            id="path5623-8-1-0"
                                          ></path>
                                          <path
                                            style={{
                                              display: "inline",
                                              fill: "none",
                                              stroke: "white",
                                              strokeWidth: "0.16500001",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "miter",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeOpacity: "1",
                                            }}
                                            d="M 125.04729,104.85792 H 125.45621"
                                            id="path5625-4-6-5"
                                          ></path>
                                          <circle
                                            style={{
                                              display: "inline",
                                              opacity: "1",
                                              fill: "none",
                                              fillOpacity: "0.63839185",
                                              stroke: "white",
                                              strokeWidth: "0.114",
                                              strokeLinecap: "butt",
                                              strokeLinejoin: "round",
                                              strokeMiterlimit: "4",
                                              strokeDasharray: "none",
                                              strokeDashoffset: "8.45947647",
                                              stopOpacity: "1",
                                              paintOrder: "markers fill stroke",
                                            }}
                                            id="path5627-9-3-3"
                                            cx="-126.07616"
                                            cy="104.86134"
                                            r="0.56729513"
                                            transform="scale(-1,1)"
                                          ></circle>
                                        </g>
                                        <path
                                          id="path5596-1-5-5-2"
                                          d="M 109.0839,98.28005 H 111.53241 A 4.1462187,4.1462187 0 0 1 115.58829,102.42529 V 102.42529 A 4.1462187,4.1462187 0 0 1 111.53248,106.57051 H 109.13438 V 106.57051 H 109.08414"
                                          style={{
                                            display: "inline",
                                            opacity: "1",
                                            fill: "none",
                                            fillOpacity: "1",
                                            stroke: "white",
                                            strokeWidth: "0",
                                            strokeLinecap: "butt",
                                            strokeLinejoin: "round",
                                            strokeMiterlimit: "4",
                                            strokeDasharray: "none",
                                            strokeDashoffset: "0",
                                            stopOpacity: "1",
                                            paintOrder: "markers fill stroke",
                                          }}
                                        ></path>
                                      </g>
                                      <text
                                        className="text_pozornica"
                                        x=""
                                        y=""
                                      ></text>
                                      <g id="svg_sektori">
                                        <path
                                          id="svg_CRTEA"
                                          d="M 184.37866,42.481362 C 179.65105,54.391508 178.12508,58.277224 178.16621,58.300738 C 178.19223,58.315594 178.31084,58.341537 178.42977,58.358367 C 178.54869,58.375175 179.31424,58.51391 180.13099,58.666658 C 187.39068,60.02441 194.48761,61.987152 202.80725,64.938172 L 203.26963,65.102177 L 203.67218,64.716928 C 203.89358,64.505061 204.93102,63.494039 205.97756,62.470211 C 209.97912,58.555583 213.5564,55.062898 213.81653,54.816549 C 213.96552,54.675473 214.07255,54.54601 214.05438,54.528881 C 213.99494,54.472764 210.88731,52.546627 209.91296,51.961953 C 206.36956,49.835686 202.36022,47.778092 198.43111,46.069472 C 194.40932,44.320534 190.09967,42.773912 185.80323,41.537645 C 185.33943,41.404192 184.93796,41.287797 184.91111,41.279005 C 184.88232,41.269604 184.66366,41.763348 184.37866,42.481362 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          <title>
                                            Sector: Crveni teleskop A
                                            {/* Slobodno u
                                        Internet prodaji: 53 Cijene: 75 € */}
                                          </title>
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_CRTEB"
                                          d="M 153.3333,46.590328 V 56.219479 L 154.16578,56.219813 C 156.78616,56.220878 160.9714,56.386581 164.05834,56.611458 C 168.42453,56.929549 174.03031,57.589843 177.39978,58.182955 C 177.59006,58.216442 177.74863,58.240826 177.75215,58.237134 C 177.7809,58.207076 184.50461,41.189494 184.49253,41.177399 C 184.4554,41.140267 182.24196,40.564545 180.98126,40.264107 C 174.981,38.834108 168.89175,37.875557 162.43662,37.344842 C 159.60738,37.112226 158.10565,37.039222 155.16043,36.991051 L 153.3333,36.961199 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          <title>
                                            Sector: Crveni teleskop B
                                            {/* Slobodno u Internet
                                prodaji: 142 Cijene: 75 € */}
                                          </title>
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_CRTEC"
                                          d="M 149.40444,36.981582 C 140.74565,37.179691 132.10089,38.365529 123.69888,40.42489 C 121.93785,40.467396 123.77718,42.39544 123.86323,43.350522 C 125.81647,48.250598 127.78279,53.145448 129.74294,58.042762 C 137.42324,56.861081 145.1924,56.272261 152.96361,56.214688 C 152.96361,49.794615 152.96361,43.374542 152.96361,36.954469 C 151.77722,36.962999 150.59072,36.963168 149.40444,36.981582 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          <title>
                                            Sector: Crveni teleskop C
                                            {/* Slobodno u Internet
                                prodaji: 142 Cijene: 75 € */}
                                          </title>
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_CRTED"
                                          d="M 121.0484,41.138628 C 114.07439,43.066096 108.04032,45.365685 101.92363,48.427047 C 98.554463,50.11329 95.922233,51.603976 93.013623,53.472965 L 91.594293,54.384987 L 94.578743,57.342162 C 96.220223,58.968608 98.665113,61.398313 100.01188,62.741508 L 102.46057,65.183639 L 104.07898,64.593897 C 110.45665,62.269877 116.72158,60.514748 123.48963,59.155975 C 125.51391,58.749555 128.88287,58.146284 129.12813,58.146284 C 129.20458,58.146284 129.28477,58.117682 129.30639,58.082715 C 129.35675,58.001207 122.47551,40.778016 122.39389,40.781226 C 122.36025,40.782567 121.75479,40.943384 121.0484,41.138628 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          <title>
                                            Sector: Crveni teleskop D
                                            {/* Slobodno u Internet
                                prodaji: 53 Cijene: 75 € */}
                                          </title>
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_PLTEA"
                                          d="M 120.97346,162.14792 C 113.99945,160.22046 107.96538,157.92087 101.84869,154.85951 C 98.479523,153.17326 95.847293,151.68258 92.938683,149.81359 L 91.51936,148.90157 L 94.503803,145.94439 C 96.145273,144.31794 98.590173,141.88824 99.936943,140.54505 L 102.38563,138.10291 L 104.00405,138.69266 C 110.38171,141.01668 116.64664,142.7718 123.41469,144.13058 C 125.43897,144.537 128.80793,145.14027 129.05319,145.14027 C 129.12964,145.14027 129.20983,145.16887 129.23146,145.20384 C 129.28181,145.28535 122.40057,162.50854 122.31895,162.50533 C 122.28531,162.50399 121.67985,162.34317 120.97346,162.14792 Z"
                                          // style={{ cursor: "pointer" }}
                                          className={
                                            showSection ===
                                            "71c4fe7d-5783-45bd-b27b-c7035f8b7ce5"
                                              ? "svg_sektor svg_selected_two cursor-pointer "
                                              : "svg_sektor svg_inactive cursor-na"
                                          }
                                          // onClick={() => [
                                          //   setSectorPTa(true),
                                          //   setShowCTA(false),
                                          //   seatCategoryIdChange(
                                          //     eventID,
                                          //     "084db105-e217-4760-9a3a-56930af9e1eb"
                                          //   ),
                                          // ]}
                                        >
                                          <title>
                                            Sector: Plavi teleskop A
                                            {/* Slobodno u Internet
                                prodaji: 53 Cijene: 120 € */}
                                          </title>
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_PLTEB"
                                          d="M 149.3295,166.30497 C 140.67071,166.10686 132.02595,164.92103 123.62394,162.86166 C 121.86292,162.81915 123.70224,160.8911 123.78829,159.93603 C 125.74154,155.03596 127.70785,150.1411 129.668,145.24379 C 137.3483,146.42547 145.11747,147.0143 152.88868,147.07186 C 152.88868,153.49193 152.88868,159.91201 152.88868,166.33208 C 151.70229,166.32356 150.51578,166.32338 149.3295,166.30497 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          <title>
                                            Sector: Plavi teleskop B
                                            {/* Slobodno u Internet
                                prodaji: 133 Cijene: 120 € */}
                                          </title>
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_PLTEC"
                                          d="M 153.25836,156.69622 V 147.06707 L 154.09085,147.06674 C 156.71122,147.06567 160.89646,146.89997 163.9834,146.67509 C 168.34959,146.357 173.95537,145.69671 177.32484,145.1036 C 177.51512,145.07011 177.67369,145.04573 177.67721,145.04942 C 177.70596,145.07948 184.42967,162.09706 184.41759,162.10915 C 184.38046,162.14629 182.16702,162.72201 180.90632,163.02245 C 174.90606,164.45244 168.81681,165.411 162.36168,165.94171 C 159.53244,166.17433 158.03071,166.24733 155.08549,166.2955 L 153.25836,166.32535 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          <title>
                                            Sector: Plavi teleskop C
                                            {/* Slobodno u Internet
                                prodaji: 139 Cijene: 120 € */}
                                          </title>
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_PLTED"
                                          d="M 184.30372,160.80519 C 179.57611,148.89504 178.05015,145.00933 178.09127,144.98581 C 178.11729,144.97096 178.2359,144.94503 178.35483,144.92819 C 178.47375,144.91138 179.2393,144.77264 180.05605,144.61989 C 187.31574,143.26214 194.41267,141.2994 202.73231,138.34838 L 203.19468,138.18438 L 203.59726,138.56962 C 203.81865,138.78149 204.85608,139.79251 205.90262,140.81634 C 209.90418,144.73097 213.48147,148.22365 213.74159,148.47 C 213.89059,148.61108 213.99763,148.74054 213.97946,148.75767 C 213.92,148.81379 210.81238,150.73992 209.83803,151.3246 C 206.29463,153.45087 202.28528,155.50846 198.35617,157.21708 C 194.33438,158.96602 190.02473,160.51264 185.72829,161.74891 C 185.26449,161.88236 184.86302,161.99875 184.83617,162.00755 C 184.80738,162.01695 184.58873,161.5232 184.30372,160.80519 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          <title>
                                            Sector: Plavi teleskop D
                                            {/* Slobodno u Internet
                                prodaji: 53 Cijene: 120 € */}
                                          </title>
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_ZUTEA"
                                          d="M 77.744597,85.271768 C 72.343643,83.107681 67.866145,81.310821 67.794591,81.27873 C 67.68018,81.227409 67.729226,81.087973 68.201797,80.120871 C 70.698868,75.010707 74.256705,69.954418 78.766569,65.10659 C 79.558291,64.255526 81.119624,62.704321 81.763084,62.129478 L 82.331321,61.62185 L 83.962145,63.233616 C 84.859089,64.120086 86.751737,65.987567 88.167992,67.383576 C 91.309706,70.480394 93.357263,72.522507 93.846783,73.047322 L 94.214283,73.441329 L 93.586053,74.487249 C 92.829973,75.745952 91.31735,78.714838 90.580559,80.386275 C 90.076353,81.529999 89.316538,83.55362 88.914945,84.822311 C 88.687486,85.540903 87.940685,88.12169 87.872681,88.424221 C 87.751414,88.963733 87.668881,89.219977 87.6185,89.213456 C 87.588836,89.209634 83.14558,87.435857 77.744597,85.271768 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                          // onClick={()=>sector_click('10', '10283', 'Žuti teleskop A', 'ZUTEA', 13)}
                                        >
                                          {/* <title>
                                Sector: Žuti teleskop A 
                                Slobodno u Internet
                                prodaji: 24 Cijene: 40 €
                              </title> */}
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_ZUTEB"
                                          d="M 63.217452,99.855547 C 63.285729,97.849121 63.44679,95.688794 63.600512,94.718084 C 64.188981,91.001762 65.317357,86.908386 66.673131,83.571486 C 67.388386,81.811084 67.466612,81.637677 67.545385,81.637556 C 67.58703,81.637495 72.111848,83.433657 77.600521,85.629018 L 87.579918,89.62054 L 87.412547,90.349415 C 86.717097,93.377749 86.294181,96.198855 86.052891,99.419525 C 86.034145,99.669761 86.016826,100.22425 86.014429,100.65176 L 86.010031,101.42901 H 74.586989 H 63.163916 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                          // onClick={()=>sector_click('10', '10283', 'Žuti teleskop B', 'ZUTEB', 14)}
                                        >
                                          {/* <title>
                                Sector: Žuti teleskop B 
                                Slobodno u Internet
                                prodaji: 63 Cijene: 40 €
                              </title> */}
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_ZUTEC"
                                          d="M 67.220985,121.01609 C 65.32036,116.58066 63.995889,111.72073 63.453494,107.19207 C 63.436023,107.04607 63.401354,106.75604 63.376482,106.54751 C 63.351609,106.33898 63.31418,106.04891 63.293281,105.90296 C 63.272383,105.75697 63.234499,104.77594 63.20905,103.72285 L 63.162793,101.80816 H 74.576252 H 85.989709 L 86.042456,103.00247 C 86.102513,104.36161 86.104273,104.38288 86.316899,106.28211 C 86.490367,107.83183 86.799479,109.73737 87.159488,111.47645 C 87.289005,112.10204 87.422162,112.75038 87.455406,112.91721 C 87.48865,113.08403 87.536391,113.27345 87.561507,113.33818 C 87.598239,113.43291 85.683842,114.26995 77.727975,117.63769 C 72.294445,119.93772 67.793863,121.8402 67.726678,121.86538 C 67.629737,121.90168 67.525336,121.72636 67.220985,121.01609 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                          // onClick={()=>sector_click('10', '10283', 'Žuti teleskop C', 'ZUTEC', 15)}
                                        >
                                          {/* <title>
                                Sector: Žuti teleskop C 
                                Slobodno u Internet
                                prodaji: 63 Cijene: 40 €
                              </title> */}
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_ZUTED"
                                          d="M 80.388475,139.74386 C 78.334674,137.67957 77.520687,136.80913 76.220572,135.28696 C 74.448645,133.21235 72.533795,130.62052 71.090119,128.34269 C 69.863286,126.40701 67.734564,122.40344 67.863961,122.27517 C 67.943429,122.19633 87.455982,113.92796 87.595843,113.91382 C 87.659084,113.90742 87.730183,114.01164 87.769462,114.16839 C 88.527455,117.19217 89.551368,120.27411 90.61626,122.73715 C 91.311921,124.3461 92.866183,127.44963 93.483473,128.46228 C 94.150103,129.55587 94.182563,129.65272 93.972273,129.92031 C 93.816093,130.11911 92.369953,131.64562 90.256494,133.84274 C 89.735179,134.38471 88.899142,135.25392 88.398666,135.7743 C 86.258632,137.99954 85.132561,139.16016 83.848886,140.46385 L 82.483952,141.85005 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                          // onClick={()=>sector_click('10', '10283', 'Žuti teleskop D', 'ZUTED', 16)}
                                        >
                                          {/* <title>
                                Sector: Žuti teleskop D
                                 Slobodno u Internet
                                prodaji: 23 Cijene: 40 €
                              </title> */}
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_CRTRA"
                                          d="M 217.84537,50.755047 C 215.82657,49.412884 213.33776,47.899508 211.47568,46.881835 C 207.18078,44.534585 202.6563,42.424175 198.09174,40.639008 C 197.25762,40.312786 196.56305,40.037221 196.54827,40.026642 C 196.52031,40.006601 199.44828,31.177998 200.4974,28.119017 L 201.09951,26.363372 L 202.06009,26.688245 C 209.6895,29.268546 217.73797,32.918004 224.85962,37.026337 C 227.95874,38.814173 232.70799,41.867313 232.70799,42.071831 C 232.70799,42.180165 227.84348,47.051035 227.73845,47.047902 C 227.69822,47.0467 227.10818,46.603097 226.42723,46.062116 C 225.74631,45.521132 225.16343,45.078511 225.13197,45.078511 C 225.02917,45.078511 221.26583,49.001562 219.36709,51.088013 C 219.18683,51.286119 219.00101,51.44538 218.95418,51.441925 C 218.90739,51.43847 218.40839,51.129376 217.84537,50.755047 Z"
                                          // style={{ cursor: "pointer" }}
                                          className={
                                            showSection ===
                                            "6f6cc823-9deb-455f-839c-0072ed1b92e2"
                                              ? "svg_sektor svg_selected cursor-pointer"
                                              : "svg_sektor svg_inactive cursor-na"
                                          }
                                          // onClick={() => [
                                          //   setShowCTA(true),
                                          //   setSectorPTa(false),

                                          //   seatCategoryIdChange(
                                          //     eventID,
                                          //     "420bad79-caf5-431a-b3b6-6e15cfcfd905"
                                          //   ),
                                          // ]}
                                        >
                                          <title>
                                            Sector: Crvena tribina A
                                            {/* Slobodno u Internet
                                prodaji: 122 Cijene: 75 € */}
                                          </title>
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_CRTRB"
                                          d="M 195.43771,39.643495 C 194.04041,39.128142 190.03396,37.82413 188.58106,37.411794 C 183.40875,35.943905 178.03965,34.774551 172.75466,33.964921 C 171.75919,33.812421 170.93125,33.67503 170.91479,33.659603 C 170.88517,33.631858 172.81308,19.893633 172.85487,19.834455 C 172.88514,19.791605 174.47596,20.013174 176.66986,20.365812 C 180.70212,21.013937 183.86591,21.638544 187.81682,22.566465 C 191.73361,23.486377 195.52575,24.544303 199.38085,25.792578 C 200.08985,26.022153 200.67915,26.219089 200.69036,26.230213 C 200.70993,26.24957 196.16722,39.869993 196.13552,39.886972 C 196.12709,39.891498 195.81306,39.781933 195.43771,39.643495 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          <title>
                                            Sector: Crvena tribina B
                                            {/* Slobodno u Internet
                                prodaji: 233 Cijene: 75 € */}
                                          </title>
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_CRTRC"
                                          d="M 169.63738,33.542758 C 165.2712,33.02292 160.88548,32.533022 156.48218,32.566615 C 156.46915,29.647173 156.4561,26.72773 156.44303,23.808288 C 154.18077,23.795131 151.91852,23.781972 149.65626,23.768811 C 149.65626,26.676136 149.65626,29.583461 149.65626,32.490786 C 145.72707,32.566212 141.80534,32.85765 137.89484,33.237003 C 137.22936,31.634667 137.43823,29.829907 137.06628,28.152764 C 136.69153,25.156925 136.30763,22.162132 135.9644,19.162461 C 144.14503,18.296805 152.39827,18.257063 160.60931,18.634752 C 164.44224,18.852312 168.26423,19.231824 172.07556,19.687962 C 172.90478,20.823292 171.76568,22.311035 171.92292,23.607009 C 171.45635,26.941741 170.97736,30.274719 170.50954,33.609274 C 170.21675,33.636902 169.92646,33.578632 169.63738,33.542758 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          <title>
                                            Sector: Crvena tribina C
                                            {/* Slobodno u Internet
                                prodaji: 281 Cijene: 75 € */}
                                          </title>
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_CRTRD"
                                          d="M 106.97236,32.677181 C 105.58512,28.769111 104.47835,25.544236 104.51283,25.510792 C 104.54732,25.477348 105.25799,25.244463 106.09212,24.993273 C 115.26381,22.231304 124.26458,20.416794 134.30077,19.306572 L 135.51404,19.172356 L 135.56485,19.329174 C 135.65169,19.597336 137.32619,33.244232 137.27814,33.292278 C 137.25315,33.317247 136.5901,33.418934 135.80467,33.518251 C 127.89995,34.517756 119.24023,36.495183 112.04475,38.943775 C 110.81443,39.362452 109.73732,39.722504 109.65118,39.743885 C 109.50607,39.779904 109.30913,39.260367 106.97236,32.677181 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          <title>
                                            Sector: Crvena tribina D
                                            {/* Slobodno u Internet
                                prodaji: 238 Cijene: 75 € */}
                                          </title>
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_CRTRE"
                                          d="M 85.191556,50.549234 C 84.601147,49.980157 83.20946,48.635873 82.098919,47.561933 C 80.988408,46.487997 80.032469,45.609319 79.974626,45.609319 C 79.916783,45.609319 79.438389,45.933491 78.911556,46.329701 C 78.384721,46.725911 77.920643,47.050083 77.880271,47.050083 C 77.801833,47.050083 71.74368,41.068947 71.74368,40.991523 C 71.74368,40.933203 74.219124,39.329585 75.762652,38.387971 C 81.588737,34.833873 87.879779,31.695629 94.454663,29.063576 C 97.662113,27.779582 103.60445,25.662436 103.98703,25.667383 C 104.04821,25.668174 105.02541,28.321046 106.58741,32.726725 C 107.96372,36.608668 109.09929,39.824682 109.11087,39.873426 C 109.12258,39.922685 108.86995,40.058339 108.54215,40.178834 C 101.39666,42.80525 93.580443,46.760805 87.326677,50.915339 C 87.034733,51.109288 86.676453,51.339061 86.530466,51.425947 L 86.265062,51.583921 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          <title>
                                            Sector: Crvena tribina E
                                            {/* Slobodno u Internet
                                prodaji: 114 Cijene: 75 € */}
                                          </title>
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_ZUTRA"
                                          d="M 52.19573,75.003813 C 47.08669,72.951704 42.906594,71.217918 42.906594,71.150958 C 42.906594,70.8165 46.198755,65.724093 47.887967,63.445605 C 53.699281,55.607079 60.635239,48.937999 69.80341,42.373442 L 71.145626,41.41239 L 74.163616,44.427543 C 75.823498,46.085878 77.181062,47.477462 77.180394,47.519951 C 77.179727,47.56244 76.702,47.969238 76.118778,48.42395 C 75.535557,48.878658 75.058377,49.342386 75.058377,49.454457 C 75.058377,49.566524 75.689644,50.317756 76.461226,51.12386 C 77.232777,51.929962 78.444171,53.195283 79.153179,53.935684 C 79.862186,54.676088 80.491876,55.369541 80.552509,55.476692 C 80.62564,55.605945 80.168356,56.099271 79.193884,56.942437 C 73.951264,61.478517 69.578773,66.324417 66.073348,71.48355 C 64.789432,73.373138 62.815949,76.674859 62.152804,78.042805 C 61.960711,78.439029 61.731858,78.756847 61.644198,78.749052 C 61.556569,78.741287 57.304739,77.055921 52.19573,75.003813 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                          // onClick={()=>sector_click('10', '10283', 'Žuta tribina A', 'ZUTRA', 26)}
                                        >
                                          <title>
                                            Sector: Žuta tribina A
                                            {/* Slobodno u Internet
                                prodaji: 100 Cijene: 40 € */}
                                          </title>
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_ZUTRB"
                                          d="M 34.135862,99.872927 C 34.475458,92.469157 36.478817,84.425843 39.818416,77.057756 C 40.707626,75.095924 42.475731,71.695791 42.606673,71.695791 C 42.722177,71.695791 61.421653,79.157592 61.498332,79.234271 C 61.521566,79.257505 61.232231,79.97167 60.855327,80.821325 C 58.093458,87.047608 56.66689,93.06442 56.325504,99.926555 L 56.252162,101.4011 H 45.158979 H 34.065765 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                          // onClick={()=>sector_click('10', '10283', 'Žuta tribina B', 'ZUTRB', 27)}
                                        >
                                          {/* <title>
                                Sector: Žuta tribina B 
                                Slobodno u Internet
                                prodaji: 252 Cijene: 40 €
                              </title> */}
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_ZUTRC"
                                          d="M 40.596762,131.24044 C 37.951914,125.76238 36.086444,120.04714 35.004991,114.10894 C 34.316275,110.32737 34.123031,108.21649 34.094399,104.16252 L 34.077897,101.83005 H 45.180636 H 56.283374 L 56.291564,103.0901 C 56.296083,103.78315 56.313251,104.42255 56.329721,104.51102 C 56.346221,104.5995 56.393146,105.32337 56.434063,106.11962 C 56.705168,111.39673 58.34958,117.96206 60.739914,123.31078 C 61.296717,124.55672 61.302025,124.57836 61.073383,124.66896 C 60.945595,124.71961 56.504069,126.59894 51.203332,128.84526 C 45.902625,131.09158 41.531135,132.92948 41.488944,132.92948 C 41.446752,132.92948 41.04528,132.16939 40.596762,131.24044 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                          // onClick={()=>sector_click('10', '10283', 'Žuta tribina C', 'ZUTRC', 28)}
                                        >
                                          {/* <title>
                                Sector: Žuta tribina C 
                                Slobodno u Internet
                                prodaji: 253 Cijene: 40 €
                              </title> */}
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_ZUTRD"
                                          d="M 67.260478,162.43474 C 58.069193,155.54613 49.953416,146.95803 44.59696,138.4523 C 43.233511,136.28718 41.661775,133.4594 41.766026,133.35898 C 41.885897,133.24354 61.439489,124.96547 61.48171,125.01232 C 61.499091,125.0316 61.742322,125.50581 62.022194,126.06613 C 66.004192,134.03801 72.260747,141.8138 79.556623,147.85827 L 80.036868,148.25617 L 77.114605,151.18719 C 75.507349,152.79925 74.19234,154.19721 74.19234,154.29372 C 74.19234,154.39027 74.626663,154.84073 75.157501,155.29471 C 75.688308,155.74871 76.12263,156.15559 76.12263,156.19885 C 76.12263,156.30351 68.855449,163.49296 68.750895,163.49175 C 68.706124,163.49123 68.035427,163.01557 67.260478,162.43474 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                          // onClick={()=>sector_click('10', '10283', 'Žuta tribina D', 'ZUTRD', 29)}
                                        >
                                          {/* <title>
                                Sector: Žuta tribina D 
                                Slobodno u Internet
                                prodaji: 97 Cijene: 40 €
                              </title> */}
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_PLTRA"
                                          d="M 96.506773,178.38939 C 91.770353,176.53445 88.848761,175.25054 84.886509,173.28275 C 79.495625,170.60551 75.131689,168.04055 70.044913,164.55948 L 69.208785,163.98728 L 72.935449,160.2728 C 74.985094,158.22983 76.687137,156.54984 76.717772,156.5395 C 76.748407,156.52916 77.360414,156.98975 78.077823,157.56302 C 78.795201,158.13632 79.40918,158.60576 79.442211,158.60626 C 79.508607,158.60722 79.533722,158.58123 82.953429,154.9725 C 84.278507,153.57414 85.38935,152.43004 85.421987,152.43004 C 85.454624,152.43004 86.186897,152.89373 87.049261,153.46041 C 89.149774,154.84076 89.952356,155.35273 91.183071,156.09741 C 95.143533,158.49372 99.325453,160.63964 103.63836,162.48873 L 105.08213,163.10771 L 101.03744,170.71937 C 98.812843,174.90578 96.965963,178.37651 96.933233,178.43207 C 96.878853,178.52443 96.842213,178.52076 96.506773,178.38939 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          <title>
                                            Sector: Plava tribina A
                                            {/* Slobodno u Internet
                                prodaji: 121 Cijene: 120 € */}
                                          </title>
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_PLTRB"
                                          d="M 118.81447,184.92946 C 110.99027,183.19326 105.16879,181.54673 99.151743,179.36805 C 97.445083,178.7501 97.284603,178.68285 97.306683,178.59514 C 97.321723,178.53538 105.35709,163.35813 105.42021,163.27021 C 105.4264,163.26162 106.07575,163.5057 106.86324,163.81259 C 112.11036,165.85751 118.01382,167.67017 123.36237,168.87869 C 124.11453,169.04863 124.73715,169.18771 124.74598,169.18771 C 124.78314,169.18771 120.8904,182.00107 120.36163,183.61922 C 120.19165,184.13947 120.00201,184.68301 119.94027,184.82713 C 119.80516,185.14227 119.78266,185.1443 118.81447,184.92946 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          <title>
                                            Sector: Plava tribina B
                                            {/* Slobodno u Internet
                                prodaji: 146 Cijene: 120 € */}
                                          </title>
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_PLTRC"
                                          d="M 189.00574,183.5857 C 188.88335,183.2947 188.82026,183.0926 187.42479,178.52118 C 184.73432,169.70763 184.32307,168.34794 184.34198,168.32905 C 184.34944,168.32155 184.79188,168.19765 185.32518,168.05369 C 188.59147,167.17185 190.45157,166.61953 192.88983,165.80755 C 196.35915,164.65218 200.25486,163.13825 203.38053,161.7307 L 203.90297,161.49543 L 207.80243,168.83704 C 209.94714,172.87491 211.7019,176.197 211.7019,176.21949 C 211.7019,176.28688 208.74721,177.51117 206.49725,178.37602 C 203.0827,179.68854 198.82923,181.1169 195.20351,182.1686 C 193.28463,182.72519 189.83729,183.64469 189.27065,183.75103 L 189.08958,183.78504 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          <title>
                                            Sector: Plava tribina C
                                            {/* Slobodno u Internet
                                prodaji: 151 Cijene: 120 € */}
                                          </title>
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_PLTRD"
                                          d="M 211.86414,175.722 C 211.72956,175.47381 204.83943,162.50326 204.26433,161.41552 C 204.23498,161.36003 204.39304,161.27142 205.14478,160.92209 C 206.32217,160.37497 208.94157,159.0594 210.191,158.38774 C 213.42381,156.64984 216.57462,154.72744 219.30689,152.82594 C 219.77566,152.49968 220.27114,152.15509 220.4079,152.06021 L 220.65656,151.88768 L 223.39189,154.61167 C 226.39638,157.60369 226.80107,157.98338 226.9177,157.91972 C 226.98336,157.8839 227.45739,157.49778 228.48913,156.63974 L 228.801,156.38038 L 231.65319,159.25614 C 234.45261,162.0787 235.14403,162.80234 235.14403,162.90962 C 235.14403,163.06513 230.58795,166.16765 227.92192,167.82756 C 223.43876,170.61886 218.49087,173.23055 213.22477,175.58527 C 212.61774,175.85672 212.1068,176.07878 212.08935,176.07878 C 212.07188,176.07878 211.97055,175.91822 211.86414,175.722 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          <title>
                                            Sector: Plava tribina D
                                            {/* Slobodno u Internet
                                prodaji: 118 Cijene: 120 € */}
                                          </title>
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_ZETEA"
                                          d="M 221.60537,139.88866 C 218.76243,137.10523 216.21685,134.60267 213.79553,132.2107 L 211.38818,129.83259 L 212.06139,128.76117 C 214.4674,124.93211 216.38301,120.56587 217.80348,115.67338 C 217.99075,115.02833 218.15082,114.4941 218.15919,114.48621 C 218.18381,114.46291 237.38373,122.15335 237.43903,122.20864 C 237.46675,122.23636 237.11593,122.98617 236.65947,123.87489 C 234.35249,128.36626 231.5501,132.42112 227.81258,136.67561 C 226.94187,137.66674 224.04493,140.6321 223.50111,141.0889 L 223.14059,141.39173 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          {/* <title>
                                Sektor: Zeleni teleskop A Tickets are sold out
                              </title> */}
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_ZETEB"
                                          d="M 227.90843,117.96125 C 222.60007,115.83598 218.25364,114.0949 218.24966,114.09217 C 218.24566,114.08944 218.34782,113.66495 218.47664,113.14885 C 219.12434,110.55411 219.68812,107.42337 219.91541,105.15952 C 219.99278,104.38876 220.10507,102.53536 220.10625,102.00938 L 220.10676,101.7815 H 231.07198 H 242.03723 L 242.03686,102.89409 C 242.03604,105.53561 241.84171,107.5238 241.30738,110.35737 C 240.64505,113.86974 239.54055,117.47702 238.08446,120.88351 C 237.8607,121.40698 237.65114,121.83301 237.61881,121.83032 C 237.58645,121.82759 233.21678,120.0865 227.90843,117.96125 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          {/* <title>
                                Sektor: Zeleni teleskop B Tickets are sold out
                              </title> */}
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_ZETEC"
                                          d="M 220.08647,100.6689 C 219.92265,96.808587 219.44496,93.589253 218.46138,89.717056 C 218.24039,88.847077 218.05573,88.090662 218.05099,88.036094 C 218.04384,87.953257 219.58558,87.283166 227.39904,83.973049 C 232.5452,81.792916 236.80537,79.996268 236.86612,79.980496 C 236.95869,79.956412 236.99916,80.002304 237.11569,80.26334 C 237.19223,80.434715 237.45899,81.021303 237.70853,81.566882 C 239.68222,85.881895 241.14519,90.988477 241.76394,95.722463 C 241.93,96.993247 241.98511,97.846664 242.02103,99.703729 L 242.05393,101.40614 H 231.08584 H 220.11775 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          {/* <title>
                                Sektor: Zeleni teleskop C Tickets are sold out
                              </title> */}
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_ZETED"
                                          d="M 217.89126,87.53207 C 217.87838,87.509958 217.75365,87.117858 217.61412,86.660756 C 216.62381,83.416429 215.067,79.663619 213.57695,76.928773 C 213.07477,76.007129 212.55456,75.123581 211.94045,74.149388 L 211.40522,73.300314 L 213.75712,70.985828 C 215.05069,69.712861 217.67812,67.124194 219.59586,65.233234 L 223.08265,61.79513 L 223.35076,62.01293 C 223.78363,62.364579 226.44612,65.051857 227.36697,66.066524 C 231.06577,70.142054 233.83864,74.043478 236.2479,78.561935 C 236.54885,79.126381 236.78623,79.595432 236.77541,79.604259 C 236.74495,79.62904 217.96764,87.57229 217.93949,87.57229 C 217.92584,87.57229 217.90416,87.554181 217.89126,87.53207 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          {/* <title>
                                Sektor: Zeleni teleskop D Tickets are sold out
                              </title> */}
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_ZETRA"
                                          d="M 234.1796,161.11173 C 230.45466,157.45049 229.20848,156.19918 229.22822,156.14 C 229.24009,156.10438 229.76034,155.6425 230.38432,155.11359 C 231.00828,154.5847 231.52868,154.10067 231.54079,154.03797 C 231.56933,153.88965 230.82189,153.07348 228.06409,150.24154 L 225.80443,147.92112 L 226.34964,147.47433 C 228.69326,145.55368 232.51811,141.72527 234.97918,138.83676 C 238.33443,134.89874 241.19854,130.59398 243.41738,126.15425 C 243.7769,125.4348 244.07959,124.84618 244.08993,124.84618 C 244.1003,124.84618 248.14176,126.45944 253.07093,128.43119 L 262.03308,132.01621 L 261.49851,133.03785 C 256.49166,142.60668 249.33322,151.29242 240.08919,159.015 C 238.27074,160.53417 235.78031,162.45771 235.63186,162.45771 C 235.58627,162.45771 234.93274,161.852 234.1796,161.11173 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          {/* <title>
                                Sektor: Zelena tribina A Tickets are sold out
                              </title> */}
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_ZETRB"
                                          d="M 253.41532,128.15324 C 248.59824,126.2221 244.56362,124.60805 244.44949,124.56643 L 244.24199,124.49075 L 244.51564,123.86085 C 246.60808,119.04439 247.94099,114.43661 248.66816,109.50578 C 248.91976,107.79982 248.99744,106.84504 249.10785,104.10291 L 249.20018,101.80907 H 259.09238 H 268.98457 L 268.93492,104.29248 C 268.88141,106.96769 268.82147,107.95027 268.57533,110.18825 C 267.82799,116.98346 265.68298,124.42354 262.69214,130.59459 L 262.17364,131.66437 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          {/* <title>
                                Sektor: Zelena tribina B Tickets are sold out
                              </title> */}
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_ZETRC"
                                          d="M 249.13918,100.95599 C 249.11622,100.69531 249.07743,99.970199 249.05299,99.344608 C 248.99023,97.738683 248.89204,96.662599 248.66956,95.14191 C 247.8254,89.372516 246.12821,83.910201 243.60114,78.829371 L 242.90174,77.423188 L 251.27855,73.876237 C 258.15015,70.966641 259.67245,70.347258 259.75028,70.429305 C 260.09254,70.790045 262.48715,75.451371 263.42447,77.581487 C 266.66376,84.942789 268.51451,92.667316 268.8704,100.31146 L 268.92248,101.42995 H 259.0517 L 249.18092,101.42992 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          {/* <title>
                                Sektor: Zelena tribina C Tickets are sold out
                              </title> */}
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_ZETRD"
                                          d="M 242.032,75.851588 C 238.83194,70.268439 234.84209,65.136157 230.17007,60.706678 C 228.4469,58.936982 226.52115,57.373135 224.76933,55.640426 C 226.23885,53.758668 228.08787,52.132141 229.69508,50.341516 C 231.89241,49.08043 227.63369,48.261731 228.57992,47.046396 C 230.09755,45.440951 231.66066,43.876137 233.26597,42.358604 C 243.62338,49.700238 252.87461,58.848549 259.39223,69.804787 C 258.29087,70.778356 256.20233,71.205092 254.75466,71.982457 C 250.74839,73.683537 246.73699,75.372536 242.73304,77.079046 C 242.49936,76.669893 242.26568,76.260741 242.032,75.851588 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          {/* <title>
                                Sektor: Zelena tribina D Tickets are sold out
                              </title> */}
                                        </path>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <path
                                          id="svg_VLAL"
                                          d="M 135.20279,171.11564 C 135.06615,171.10882 134.98618,171.10878 134.9775,171.11743 C 134.87142,171.22354 130.41976,186.92975 130.48855,186.95533 C 130.52394,186.9685 131.67974,187.10553 133.05705,187.25925 C 137.41779,187.74601 141.44151,188.04861 145.57848,188.20175 C 147.91686,188.28833 150.34097,188.31501 152.79736,188.28866 V 180.74163 L 152.69145,180.72636 L 152.80209,180.72802 L 149.58496,180.69905 L 149.55599,176.45013 L 149.52702,172.20182 L 148.83228,172.14152 C 148.45039,172.10838 147.33662,172.05306 146.35719,172.01852 C 143.92736,171.93277 140.62738,171.67701 137.58266,171.33798 C 136.53403,171.22121 135.61265,171.13622 135.20279,171.11564 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          {/* <title>
                                Sektor: Loža A Lijevo Tickets are sold out
                              </title> */}
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_VLAD"
                                          d="M 173.85715,170.53542 C 173.83057,170.50884 172.81269,170.63072 171.59515,170.80595 C 167.28701,171.42603 162.49035,171.86887 158.7033,171.99586 L 156.56801,172.0672 V 176.37784 V 180.68848 L 153.26105,180.65961 V 188.19233 C 159.94376,188.11247 166.86223,187.62698 172.98664,186.78019 C 174.86888,186.51994 178.24421,185.99821 178.28447,185.96155 C 178.3205,185.92869 173.92095,170.59922 173.85715,170.53542 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          {/* <title>
                                Sektor: Loža A Desno Tickets are sold out
                              </title> */}
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_VLBL"
                                          d="M 128.06012,186.60821 C 125.08743,186.14048 120.60247,185.30919 120.5056,185.20796 C 120.47553,185.17655 125.04931,169.31901 125.10977,169.24493 C 125.11715,169.23593 125.85899,169.38465 126.75831,169.57541 C 128.42008,169.9279 131.71335,170.51896 133.4936,170.78425 C 134.37163,170.91509 134.47321,170.94628 134.46104,171.08143 C 134.45356,171.16447 133.4857,174.7541 132.31032,179.05834 L 130.17314,186.88424 L 129.94673,186.87685 C 129.82225,186.87279 128.97324,186.75188 128.06012,186.60821 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          {/* <title>
                                Sektor: Loža B Lijevo Tickets are sold out
                              </title> */}
                                        </path>
                                        <g></g>
                                        <path
                                          id="svg_VLBD"
                                          d="M 178.54309,185.88403 C 178.52329,185.80592 177.55357,182.30809 176.38818,178.11108 C 175.22276,173.91408 174.29008,170.4586 174.31556,170.43223 C 174.34104,170.40587 174.93761,170.28197 175.64129,170.15693 C 177.45517,169.83457 180.37825,169.21681 182.28776,168.75232 C 183.18565,168.5339 183.92703,168.36392 183.93527,168.37459 C 183.94346,168.38525 184.97799,171.87147 186.23415,176.12174 C 187.73275,181.19239 188.48966,183.86703 188.43546,183.90045 C 188.21382,184.03717 182.47992,185.29973 180.0836,185.73947 C 179.47577,185.851 178.88863,185.96112 178.77878,185.98417 C 178.62941,186.01549 178.57005,185.99026 178.54309,185.88403 Z"
                                          style={{ cursor: "not-allowed" }}
                                          className="svg_sektor svg_inactive"
                                        >
                                          {/* <title>
                                Sektor: Loža B Desno Tickets are sold out
                              </title> */}
                                        </path>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                        <g></g>
                                      </g>
                                    </svg>
                                  </div>
                                  <div>
                                    <h3>{text_selectseats}</h3>
                                    <h4 className="me-4">
                                      {selectedSectorName}
                                    </h4>
                                    <div className="seatscroll-season">
                                      {Object.keys(seatDetails)?.map(function (
                                        rowstart
                                      ) {
                                        return (
                                          <>
                                            <div className="m-3">
                                              <div className=" d-flex  ">
                                                <div className="d-flex  ">
                                                  <h5
                                                    className=""
                                                    style={{
                                                      width: "40px",
                                                      marginTop: "5px",
                                                    }}
                                                  >
                                                    {rowstart} .
                                                  </h5>

                                                  {seatDetails[rowstart].map(
                                                    (seat, index) => {
                                                      return (
                                                        <>
                                                          <div
                                                            className="seats "
                                                            type="A"
                                                          >
                                                            <div
                                                              className={
                                                                seat.isvisible ===
                                                                false
                                                                  ? "d-none"
                                                                  : seat?.seasonSeats ===
                                                                      true &&
                                                                    seat?.sold ===
                                                                      true
                                                                  ? "seasonSoldOutSeat"
                                                                  : "selectSeasonSeat"
                                                              }
                                                            >
                                                              <input
                                                                type="checkbox"
                                                                id={seat?._id}
                                                                disabled={
                                                                  seat?.seasonSeats ===
                                                                    true &&
                                                                  seat?.sold ===
                                                                    false
                                                                    ? false
                                                                    : true
                                                                }
                                                                onChange={(
                                                                  e
                                                                ) => [
                                                                  console.log(
                                                                    seat
                                                                  ),
                                                                  handleSelectSeats(
                                                                    seat
                                                                  ),
                                                                  SeatDataBeforNext(
                                                                    e.target
                                                                      .checked,
                                                                    seat,
                                                                    seat.seat_unique_id
                                                                  ),
                                                                ]}
                                                              />
                                                              <label
                                                                for={seat?._id}
                                                              >
                                                                {seat?.column}{" "}
                                                                <br />
                                                                {seat?.seasonSeats ===
                                                                true ? (
                                                                  <>
                                                                    {
                                                                      seasonCurrency
                                                                    }{" "}
                                                                    {
                                                                      seasonPrice
                                                                    }
                                                                  </>
                                                                ) : (
                                                                  <>
                                                                    {
                                                                      seat?.currency
                                                                    }{" "}
                                                                    {
                                                                      seat?.seat_price
                                                                    }
                                                                  </>
                                                                )}
                                                              </label>
                                                            </div>
                                                          </div>
                                                        </>
                                                      );
                                                    }
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </>
                                        );
                                      })}
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="main-card mt-5">
                                  <div className="bp-content bp-form w-100 seatscroll-season">
                                    <table className="OwnerTable w-100 mt-5">
                                      <thead>
                                        <tr>
                                          <th className="OwnerTableHead">
                                            {text_seat}
                                          </th>
                                          <th className="OwnerTableHead">
                                            {text_quantity}
                                          </th>
                                          <th className="OwnerTableHead">
                                            {text_price}
                                          </th>
                                          <th className="OwnerTableHead">
                                            {text_owner_fullName}
                                          </th>
                                          <th className="OwnerTableHead">
                                            {text_ownerpnem}
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {SelectedseatDetailsarray.map(
                                          (sd, index) => {
                                            return (
                                              <>
                                                <tr key={sd.seat_unique_id}>
                                                  <td className="OwnerTableBody p-2">
                                                    {sd?.seatD?.seat_name}
                                                  </td>
                                                  <td className="OwnerTableBody p-2">
                                                    1
                                                  </td>
                                                  <td className="OwnerTableBody p-2">
                                                    {sd?.seatD?.currency}{" "}
                                                    {sd?.seatD?.seat_price}
                                                  </td>
                                                  <td className="OwnerTableBody p-2">
                                                    <input
                                                      type="text"
                                                      className="form-control w-75 "
                                                      defaultValue={
                                                        sessionStorage.getItem(
                                                          "userfirstname"
                                                        ) +
                                                        " " +
                                                        sessionStorage.getItem(
                                                          "userlastname"
                                                        )
                                                      }
                                                      onChange={(e) => [
                                                        handleInputChangeOwnerName(
                                                          e,
                                                          index
                                                        ),
                                                        setShowOwnerErr(false),
                                                      ]}
                                                    />
                                                  </td>
                                                  <td className=" OwnerTableBody p-2">
                                                    <input
                                                      type="text"
                                                      className="form-control w-100"
                                                      defaultValue={sessionStorage.getItem(
                                                        "useremail"
                                                      )}
                                                      onChange={(e) => [
                                                        handleInputChangeOwnerEmail(
                                                          e,
                                                          index
                                                        ),
                                                        setShowOwnerErr(false),
                                                      ]}
                                                    />
                                                  </td>
                                                </tr>
                                              </>
                                            );
                                          }
                                        )}
                                      </tbody>
                                    </table>
                                    {showOwnerErr === true ? (
                                      <>
                                        <p className="text-center validation-err">
                                          {text_usernotfound}{" "}
                                          <b>
                                            {" "}
                                            (
                                            {notFoundList.map((list) => {
                                              return <>{list}, &nbsp;</>;
                                            })}
                                            )
                                          </b>{" "}
                                          {text_onceagain}
                                        </p>
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                          <div className="col-xl-4 col-lg-12 col-md-12">
                            <div className="main-card order-summary">
                              <div className="bp-title">
                                <h4>{text_billing}</h4>
                              </div>
                              {seasonData.map((e) => {
                                return (
                                  <>
                                    <div className="order-summary-content p_30">
                                      <div className="event-order-dt">
                                        <div className="event-thumbnail-img new-event-thumbnail-img">
                                          <img
                                            src={
                                              e?.url === "" ||
                                              e?.url === undefined
                                                ? img1
                                                : e?.url
                                            }
                                            alt=""
                                          />
                                        </div>
                                      </div>
                                      <div className="event-order-dt-content new-event-order-dt-content mt-3">
                                        <h5>{e?.ticketname}</h5>

                                        <div className="category-type">
                                          <b> {text_venueAddress}:- </b>
                                          {
                                            e?.event_details[0]?.venuedetails[0]
                                              ?.venuename
                                          }
                                          ,{" "}
                                          {
                                            e?.event_details[0]?.venuedetails[0]
                                              ?.address
                                          }
                                          ,{" "}
                                          {
                                            e?.event_details[0]?.venuedetails[0]
                                              ?.city
                                          }
                                          ,{" "}
                                          {
                                            e?.event_details[0]?.venuedetails[0]
                                              ?.state
                                          }
                                          ,{" "}
                                          {
                                            e?.event_details[0]?.venuedetails[0]
                                              ?.country
                                          }
                                          ,{" "}
                                          {
                                            e?.event_details[0]?.venuedetails[0]
                                              ?.zipcode
                                          }
                                        </div>
                                      </div>
                                      {selecteSeatName.length > 0 ? (
                                        <>
                                          <div className="order-total-block">
                                            <div className="order-total-dt">
                                              <div className="order-text">
                                                {text_pricePerTicket}
                                              </div>
                                              <div className="order-number">
                                                {seasonCurrency} {seasonPrice}
                                              </div>
                                            </div>

                                            <div className="order-total-dt">
                                              <div className="order-text">
                                                {text_quantity}
                                              </div>
                                              <div className="order-number">
                                                {selectedIds.length} x{" "}
                                                {text_tickets}
                                              </div>
                                            </div>
                                            <div className="order-total-dt">
                                              <div className="order-text">
                                                {text_ticketlist}
                                              </div>
                                              <div
                                                className="order-number"
                                                style={{
                                                  wordBreak: "break-word",
                                                }}
                                              >
                                                {selecteSeatName.map((name) => {
                                                  return <> {name},</>;
                                                })}
                                              </div>
                                            </div>

                                            <div className="divider-line"></div>
                                            <div className="order-total-dt">
                                              <div className="order-text">
                                                {text_total}
                                              </div>
                                              <div className="order-number ttl-clr">
                                                {seasonCurrency}{" "}
                                                {selectedIds.length *
                                                  seasonPrice}{" "}
                                              </div>
                                            </div>
                                          </div>
                                          {showOwnerDetails === true ? (
                                            <>
                                              <div className="confirmation-btn">
                                                <button
                                                  className="main-btn btn-hover h_50 w-100 mt-5"
                                                  type="button"
                                                  onClick={() => [
                                                    sessionStorage.setItem(
                                                      "ownerDetails",
                                                      JSON.stringify(
                                                        ownerinputData
                                                      )
                                                    ),
                                                    confirmOwnerHandle(),
                                                  ]}
                                                >
                                                  {text_confirm}
                                                </button>
                                              </div>
                                            </>
                                          ) : (
                                            <>
                                              <div className="confirmation-btn">
                                                <button
                                                  className="main-btn btn-hover h_50 w-100 mt-5"
                                                  type="button"
                                                  onClick={handleSeasonCheckout}
                                                >
                                                  {text_checkout}
                                                </button>
                                                <span>{text_taxes_info}</span>
                                              </div>
                                            </>
                                          )}
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </>
              ) : (
                <>
                  <div className="d-flex justify-content-center mb-3">
                    <div className=" w-50 res-payment-season">
                      {clientSecret && (
                        <Elements options={options} stripe={stripePromise}>
                          <SeasonalCheckOut
                            clientSecret={clientSecret}
                            ticketid={selectedIds}
                          />
                        </Elements>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
            <br />
            <br />
          </div>
        </div>
      </div>
      <Dialog
        fullScreen={fullScreen}
        open={openloginInfo}
        onClose={handleCloseloginInfo}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" className="text-center">
          <BiLogIn className="Email-icon hometextnight" />
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <h3 className="text-center hometextnight">
              {text_info_please_login}
            </h3>
            <br />
          </DialogContentText>
          <Divider />
        </DialogContent>
        <>
          <div className="d-flex justify-content-center mb-3">
            <button
              className="main-btn btn-hover "
              onClick={handleCloseloginInfo}
            >
              {text_okay}
            </button>
          </div>
        </>
      </Dialog>
      <ToastContainer />
      <Footer />
    </>
  );
}

export default SeasonalEvent;
